/* eslint-disable max-len */
export const KADASTRALEGEMEENTECODES = [
    {
        "Code": 1,
        "Waarde": "Aalburg",
        "Toelichting": "ABG00"
    },
    {
        "Code": 2,
        "Waarde": "Aalsmeer",
        "Toelichting": "AMR03"
    },
    {
        "Code": 3,
        "Waarde": "Aalst Gelderland",
        "Toelichting": "AAL02"
    },
    {
        "Code": 4,
        "Waarde": "Aalst Noord-Brabant",
        "Toelichting": "AAL01"
    },
    {
        "Code": 5,
        "Waarde": "Aalten",
        "Toelichting": "ATN02"
    },
    {
        "Code": 6,
        "Waarde": "Aardenburg",
        "Toelichting": "ADB00"
    },
    {
        "Code": 7,
        "Waarde": "Aarlanderveen",
        "Toelichting": "ALD00"
    },
    {
        "Code": 8,
        "Waarde": "Aarle-Rixtel",
        "Toelichting": "ALE00"
    },
    {
        "Code": 9,
        "Waarde": "Abbekerk",
        "Toelichting": "ABK00"
    },
    {
        "Code": 10,
        "Waarde": "Abbenbroek",
        "Toelichting": "ABB00"
    },
    {
        "Code": 11,
        "Waarde": "Abcoude",
        "Toelichting": "ACD00"
    },
    {
        "Code": 12,
        "Waarde": "Abstede",
        "Toelichting": "ASD40"
    },
    {
        "Code": 13,
        "Waarde": "Adorp",
        "Toelichting": "ADP00"
    },
    {
        "Code": 14,
        "Waarde": "Aduard",
        "Toelichting": "ADA00"
    },
    {
        "Code": 15,
        "Waarde": "Aerdt",
        "Toelichting": "AER00"
    },
    {
        "Code": 16,
        "Waarde": "Afferden",
        "Toelichting": "AFD00"
    },
    {
        "Code": 17,
        "Waarde": "Akersloot",
        "Toelichting": "AKS01"
    },
    {
        "Code": 18,
        "Waarde": "Akkerwoude",
        "Toelichting": "AKW00"
    },
    {
        "Code": 19,
        "Waarde": "Akkrum",
        "Toelichting": "AKM02"
    },
    {
        "Code": 20,
        "Waarde": "Alblasserdam",
        "Toelichting": "ABS01"
    },
    {
        "Code": 21,
        "Waarde": "Alem",
        "Toelichting": "ALM00"
    },
    {
        "Code": 22,
        "Waarde": "Alkemade",
        "Toelichting": "AKM01"
    },
    {
        "Code": 23,
        "Waarde": "Alkmaar",
        "Toelichting": "AMR01"
    },
    {
        "Code": 24,
        "Waarde": "Almen",
        "Toelichting": "AMN00"
    },
    {
        "Code": 25,
        "Waarde": "Almere",
        "Toelichting": "AMR04"
    },
    {
        "Code": 26,
        "Waarde": "Alphen",
        "Toelichting": "APN02"
    },
    {
        "Code": 27,
        "Waarde": "Alphen aan den Rijn",
        "Toelichting": "APN01"
    },
    {
        "Code": 28,
        "Waarde": "Alphen en Riel",
        "Toelichting": "APN03"
    },
    {
        "Code": 29,
        "Waarde": "Ambt-Almelo",
        "Toelichting": "AML01"
    },
    {
        "Code": 30,
        "Waarde": "Ambt-Delden",
        "Toelichting": "DDN01"
    },
    {
        "Code": 31,
        "Waarde": "Ambt-Doetinchem",
        "Toelichting": "DTC01"
    },
    {
        "Code": 32,
        "Waarde": "Ambt-Hardenberg",
        "Toelichting": "HDB01"
    },
    {
        "Code": 33,
        "Waarde": "Ambt-Ommen",
        "Toelichting": "OMN01"
    },
    {
        "Code": 34,
        "Waarde": "Amby",
        "Toelichting": "ABY00"
    },
    {
        "Code": 35,
        "Waarde": "Ameide",
        "Toelichting": "AMD00"
    },
    {
        "Code": 36,
        "Waarde": "Amerongen",
        "Toelichting": "AMR02"
    },
    {
        "Code": 37,
        "Waarde": "Amersfoort",
        "Toelichting": "AMF00"
    },
    {
        "Code": 38,
        "Waarde": "Ammerstol",
        "Toelichting": "AMS01"
    },
    {
        "Code": 39,
        "Waarde": "Ammerzoden",
        "Toelichting": "AMZ00"
    },
    {
        "Code": 40,
        "Waarde": "Amstelveen",
        "Toelichting": "ASV00"
    },
    {
        "Code": 41,
        "Waarde": "Amstenrade",
        "Toelichting": "ASR00"
    },
    {
        "Code": 42,
        "Waarde": "Amsterdam",
        "Toelichting": "ASD02;ASD03;ASD04;ASD05;ASD06;ASD07;ASD08;ASD09;ASD10;ASD11;ASD12;ASD13;ASD14;ASD15;ASD16;ASD17;ASD18;ASD19;ASD20;ASD21;ASD22;ASD23;ASD24;ASD25;ASD26;ASD27;ASD28;ASD29;ASD30;ASD31;ASD32;ASD33;ASD34;ASD35;ASD36;ASD37;ASD38;ASD39;ASD41;ASD42;ASD43"
    },
    {
        "Code": 43,
        "Waarde": "Andijk",
        "Toelichting": "ADK00"
    },
    {
        "Code": 44,
        "Waarde": "Angeren",
        "Toelichting": "AGR00"
    },
    {
        "Code": 45,
        "Waarde": "Angerlo",
        "Toelichting": "AGL00"
    },
    {
        "Code": 46,
        "Waarde": "Anjum",
        "Toelichting": "AJM00"
    },
    {
        "Code": 47,
        "Waarde": "Ankeveen",
        "Toelichting": "AKV00"
    },
    {
        "Code": 48,
        "Waarde": "Anloo",
        "Toelichting": "ALO00"
    },
    {
        "Code": 49,
        "Waarde": "Anna Paulowna",
        "Toelichting": "ANA01"
    },
    {
        "Code": 50,
        "Waarde": "Apeldoorn",
        "Toelichting": "APD01;APD02;APD03;APD04"
    },
    {
        "Code": 51,
        "Waarde": "Appeltern",
        "Toelichting": "APT00"
    },
    {
        "Code": 52,
        "Waarde": "Appingedam",
        "Toelichting": "APG00"
    },
    {
        "Code": 53,
        "Waarde": "Arcen en Velden",
        "Toelichting": "ACN00"
    },
    {
        "Code": 54,
        "Waarde": "Arkel",
        "Toelichting": "AKL00"
    },
    {
        "Code": 55,
        "Waarde": "Arnemuiden",
        "Toelichting": "ANM00"
    },
    {
        "Code": 56,
        "Waarde": "Arnhem",
        "Toelichting": "AHM01;AHM02;AHM03;AHM04;AHM05"
    },
    {
        "Code": 57,
        "Waarde": "Arum",
        "Toelichting": "ARM00"
    },
    {
        "Code": 58,
        "Waarde": "Asperen",
        "Toelichting": "APR00"
    },
    {
        "Code": 59,
        "Waarde": "Assen",
        "Toelichting": "ASN00"
    },
    {
        "Code": 60,
        "Waarde": "Assendelft",
        "Toelichting": "ASD01"
    },
    {
        "Code": 61,
        "Waarde": "Asten",
        "Toelichting": "ATN01"
    },
    {
        "Code": 62,
        "Waarde": "Avereest",
        "Toelichting": "AVE00"
    },
    {
        "Code": 63,
        "Waarde": "Axel",
        "Toelichting": "AEL00"
    },
    {
        "Code": 64,
        "Waarde": "Baambrugge",
        "Toelichting": "BBG02"
    },
    {
        "Code": 65,
        "Waarde": "Baard",
        "Toelichting": "BAA02"
    },
    {
        "Code": 66,
        "Waarde": "Baardwijk",
        "Toelichting": "BWK03"
    },
    {
        "Code": 67,
        "Waarde": "Baarle-Nassau",
        "Toelichting": "BLE01"
    },
    {
        "Code": 68,
        "Waarde": "Baarn",
        "Toelichting": "BAA01"
    },
    {
        "Code": 69,
        "Waarde": "Baexem",
        "Toelichting": "BXM00"
    },
    {
        "Code": 70,
        "Waarde": "Baflo",
        "Toelichting": "BLO00"
    },
    {
        "Code": 71,
        "Waarde": "Bahr en Lathum",
        "Toelichting": "BAH00"
    },
    {
        "Code": 72,
        "Waarde": "Bakel en Milheeze",
        "Toelichting": "BKL02"
    },
    {
        "Code": 73,
        "Waarde": "Balgoy",
        "Toelichting": "BGY00"
    },
    {
        "Code": 74,
        "Waarde": "Balk",
        "Toelichting": "BAL00"
    },
    {
        "Code": 75,
        "Waarde": "Ballum",
        "Toelichting": "BLM00"
    },
    {
        "Code": 76,
        "Waarde": "Barendrecht",
        "Toelichting": "BRD00"
    },
    {
        "Code": 77,
        "Waarde": "Barneveld",
        "Toelichting": "BNV00"
    },
    {
        "Code": 78,
        "Waarde": "Barsingerhorn",
        "Toelichting": "BSG00"
    },
    {
        "Code": 79,
        "Waarde": "Barwoutswaarder",
        "Toelichting": "BWW00"
    },
    {
        "Code": 80,
        "Waarde": "Batenburg",
        "Toelichting": "BTB00"
    },
    {
        "Code": 81,
        "Waarde": "Bath",
        "Toelichting": "BAT00"
    },
    {
        "Code": 82,
        "Waarde": "Bathmen",
        "Toelichting": "BMN02"
    },
    {
        "Code": 83,
        "Waarde": "Bedum",
        "Toelichting": "BDM00"
    },
    {
        "Code": 84,
        "Waarde": "Beegden",
        "Toelichting": "BDN00"
    },
    {
        "Code": 85,
        "Waarde": "Beek",
        "Toelichting": "BEE02"
    },
    {
        "Code": 86,
        "Waarde": "Beek en Donk",
        "Toelichting": "BEE01"
    },
    {
        "Code": 87,
        "Waarde": "Beekbergen",
        "Toelichting": "BBG01"
    },
    {
        "Code": 88,
        "Waarde": "Beemster",
        "Toelichting": "BSR00"
    },
    {
        "Code": 89,
        "Waarde": "Beers",
        "Toelichting": "BEE04"
    },
    {
        "Code": 90,
        "Waarde": "Beerta",
        "Toelichting": "BTA00"
    },
    {
        "Code": 91,
        "Waarde": "Beesd",
        "Toelichting": "BEE03"
    },
    {
        "Code": 92,
        "Waarde": "Beesel",
        "Toelichting": "BSL02"
    },
    {
        "Code": 93,
        "Waarde": "Beetgum",
        "Toelichting": "BGM01"
    },
    {
        "Code": 94,
        "Waarde": "Beets",
        "Toelichting": "BEE05"
    },
    {
        "Code": 95,
        "Waarde": "Beetsterzwaag",
        "Toelichting": "BSZ00"
    },
    {
        "Code": 96,
        "Waarde": "Beilen",
        "Toelichting": "BLN00"
    },
    {
        "Code": 97,
        "Waarde": "Belfeld",
        "Toelichting": "BFD00"
    },
    {
        "Code": 98,
        "Waarde": "Bellingwolde",
        "Toelichting": "BLW00"
    },
    {
        "Code": 99,
        "Waarde": "Beltrum",
        "Toelichting": "BTM00"
    },
    {
        "Code": 100,
        "Waarde": "Bemelen",
        "Toelichting": "BML01"
    },
    {
        "Code": 101,
        "Waarde": "Bemmel",
        "Toelichting": "BML02"
    },
    {
        "Code": 102,
        "Waarde": "Bennebroek",
        "Toelichting": "BNB00"
    },
    {
        "Code": 103,
        "Waarde": "Bennekom",
        "Toelichting": "BNK01"
    },
    {
        "Code": 104,
        "Waarde": "Benschop",
        "Toelichting": "BSP00"
    },
    {
        "Code": 105,
        "Waarde": "Benthuizen",
        "Toelichting": "BHZ02"
    },
    {
        "Code": 106,
        "Waarde": "Berg en Terblijt",
        "Toelichting": "BER01"
    },
    {
        "Code": 107,
        "Waarde": "Bergambacht",
        "Toelichting": "BAB00"
    },
    {
        "Code": 108,
        "Waarde": "Bergeijk",
        "Toelichting": "BEK00"
    },
    {
        "Code": 109,
        "Waarde": "Bergen Limburg",
        "Toelichting": "BGN02"
    },
    {
        "Code": 110,
        "Waarde": "Bergen Noord-Holland",
        "Toelichting": "BGN03"
    },
    {
        "Code": 111,
        "Waarde": "Bergen op Zoom",
        "Toelichting": "BGN01"
    },
    {
        "Code": 112,
        "Waarde": "Bergh",
        "Toelichting": "BER02"
    },
    {
        "Code": 113,
        "Waarde": "Bergharen",
        "Toelichting": "BHR02"
    },
    {
        "Code": 114,
        "Waarde": "Berghem",
        "Toelichting": "BHM00"
    },
    {
        "Code": 115,
        "Waarde": "Bergschenhoek",
        "Toelichting": "BSH00"
    },
    {
        "Code": 116,
        "Waarde": "Bergum",
        "Toelichting": "BGM02"
    },
    {
        "Code": 117,
        "Waarde": "Berkel",
        "Toelichting": "BKL04"
    },
    {
        "Code": 118,
        "Waarde": "Berkel en Rodenrijs",
        "Toelichting": "BKL01"
    },
    {
        "Code": 119,
        "Waarde": "Berkenwoude",
        "Toelichting": "BKW00"
    },
    {
        "Code": 120,
        "Waarde": "Berlicum",
        "Toelichting": "BLC00"
    },
    {
        "Code": 121,
        "Waarde": "Berlikum",
        "Toelichting": "BLK00"
    },
    {
        "Code": 122,
        "Waarde": "Bernisse",
        "Toelichting": "BNS04"
    },
    {
        "Code": 123,
        "Waarde": "Besoijen",
        "Toelichting": "BSE00"
    },
    {
        "Code": 124,
        "Waarde": "Best",
        "Toelichting": "BES00"
    },
    {
        "Code": 125,
        "Waarde": "Beuningen",
        "Toelichting": "BNG00"
    },
    {
        "Code": 126,
        "Waarde": "Beusichem",
        "Toelichting": "BSC00"
    },
    {
        "Code": 127,
        "Waarde": "Beverwijk",
        "Toelichting": "BVW00"
    },
    {
        "Code": 128,
        "Waarde": "Bierum",
        "Toelichting": "BRM01"
    },
    {
        "Code": 129,
        "Waarde": "Bingelrade",
        "Toelichting": "BGR02"
    },
    {
        "Code": 130,
        "Waarde": "Birdaard",
        "Toelichting": "BDD00"
    },
    {
        "Code": 131,
        "Waarde": "Bladel",
        "Toelichting": "BDL01"
    },
    {
        "Code": 132,
        "Waarde": "Blankenham",
        "Toelichting": "BKH00"
    },
    {
        "Code": 133,
        "Waarde": "Blaricum",
        "Toelichting": "BRC00"
    },
    {
        "Code": 134,
        "Waarde": "Bleiswijk",
        "Toelichting": "BWK02"
    },
    {
        "Code": 135,
        "Waarde": "Blesdijke",
        "Toelichting": "BDK00"
    },
    {
        "Code": 136,
        "Waarde": "Bleskensgraaf",
        "Toelichting": "BKG00"
    },
    {
        "Code": 137,
        "Waarde": "Blija",
        "Toelichting": "BJA00"
    },
    {
        "Code": 138,
        "Waarde": "Bloemendaal",
        "Toelichting": "BMD00"
    },
    {
        "Code": 139,
        "Waarde": "Blokzijl",
        "Toelichting": "BZL00"
    },
    {
        "Code": 140,
        "Waarde": "Bocholtz",
        "Toelichting": "BCZ00"
    },
    {
        "Code": 141,
        "Waarde": "Bodegraven",
        "Toelichting": "BDG00"
    },
    {
        "Code": 142,
        "Waarde": "Boekel",
        "Toelichting": "BKL05"
    },
    {
        "Code": 143,
        "Waarde": "Bolsward",
        "Toelichting": "BWD01"
    },
    {
        "Code": 144,
        "Waarde": "Boornbergum",
        "Toelichting": "BBG03"
    },
    {
        "Code": 145,
        "Waarde": "Borculo",
        "Toelichting": "BCL00"
    },
    {
        "Code": 146,
        "Waarde": "Borger",
        "Toelichting": "BGR01"
    },
    {
        "Code": 147,
        "Waarde": "Borgharen",
        "Toelichting": "BHR01"
    },
    {
        "Code": 148,
        "Waarde": "Borkel en Schaft",
        "Toelichting": "BKL06"
    },
    {
        "Code": 149,
        "Waarde": "Born",
        "Toelichting": "BOR00"
    },
    {
        "Code": 150,
        "Waarde": "Borne",
        "Toelichting": "BNE00"
    },
    {
        "Code": 151,
        "Waarde": "Borsele",
        "Toelichting": "BSL01"
    },
    {
        "Code": 152,
        "Waarde": "Boskoop",
        "Toelichting": "BKP00"
    },
    {
        "Code": 153,
        "Waarde": "Bovenkarspel",
        "Toelichting": "BVK00"
    },
    {
        "Code": 154,
        "Waarde": "Boxmeer",
        "Toelichting": "BMR00"
    },
    {
        "Code": 155,
        "Waarde": "Boxtel",
        "Toelichting": "BTL00"
    },
    {
        "Code": 156,
        "Waarde": "Brakel",
        "Toelichting": "BKL08"
    },
    {
        "Code": 157,
        "Waarde": "Brandwijk",
        "Toelichting": "BWK01"
    },
    {
        "Code": 158,
        "Waarde": "Breda",
        "Toelichting": "BDA00"
    },
    {
        "Code": 159,
        "Waarde": "Brederwiede",
        "Toelichting": "BDW00"
    },
    {
        "Code": 160,
        "Waarde": "Bredevoort",
        "Toelichting": "BDV00"
    },
    {
        "Code": 161,
        "Waarde": "Breukelen",
        "Toelichting": "BKL09"
    },
    {
        "Code": 162,
        "Waarde": "Breukelen Sint Pieters",
        "Toelichting": "BKL03"
    },
    {
        "Code": 163,
        "Waarde": "Breukelen-Nijenrode",
        "Toelichting": "BKL07"
    },
    {
        "Code": 164,
        "Waarde": "Brielle",
        "Toelichting": "BLE02"
    },
    {
        "Code": 165,
        "Waarde": "Broek in Waterland",
        "Toelichting": "BRO00"
    },
    {
        "Code": 166,
        "Waarde": "Broekhuizen",
        "Toelichting": "BHZ01"
    },
    {
        "Code": 167,
        "Waarde": "Broeksittard",
        "Toelichting": "BST02"
    },
    {
        "Code": 168,
        "Waarde": "Brouwershaven",
        "Toelichting": "BWH00"
    },
    {
        "Code": 169,
        "Waarde": "Bruinisse",
        "Toelichting": "BNS00"
    },
    {
        "Code": 170,
        "Waarde": "Brummen",
        "Toelichting": "BMN01"
    },
    {
        "Code": 171,
        "Waarde": "Brunssum",
        "Toelichting": "BSM02"
    },
    {
        "Code": 172,
        "Waarde": "Budel",
        "Toelichting": "BDL02"
    },
    {
        "Code": 173,
        "Waarde": "Buggenum",
        "Toelichting": "BGN04"
    },
    {
        "Code": 174,
        "Waarde": "Buitenpost",
        "Toelichting": "BTP00"
    },
    {
        "Code": 175,
        "Waarde": "Bunde",
        "Toelichting": "BDE00"
    },
    {
        "Code": 176,
        "Waarde": "Bunnik",
        "Toelichting": "BNK02"
    },
    {
        "Code": 177,
        "Waarde": "Bunschoten",
        "Toelichting": "BST01"
    },
    {
        "Code": 178,
        "Waarde": "Buren",
        "Toelichting": "BRN00"
    },
    {
        "Code": 179,
        "Waarde": "Burgwerd",
        "Toelichting": "BWD02"
    },
    {
        "Code": 180,
        "Waarde": "Burum",
        "Toelichting": "BRM02"
    },
    {
        "Code": 181,
        "Waarde": "Bussum",
        "Toelichting": "BSM01"
    },
    {
        "Code": 182,
        "Waarde": "Buurmalsen",
        "Toelichting": "BMS00"
    },
    {
        "Code": 183,
        "Waarde": "Cadier en Keer",
        "Toelichting": "CDR00"
    },
    {
        "Code": 184,
        "Waarde": "Cadzand",
        "Toelichting": "CZD00"
    },
    {
        "Code": 185,
        "Waarde": "Callantsoog",
        "Toelichting": "CLO00"
    },
    {
        "Code": 186,
        "Waarde": "Capelle",
        "Toelichting": "CPL02"
    },
    {
        "Code": 187,
        "Waarde": "Capelle aan den IJssel",
        "Toelichting": "CPL01"
    },
    {
        "Code": 188,
        "Waarde": "Castricum",
        "Toelichting": "CTC00"
    },
    {
        "Code": 189,
        "Waarde": "Catharijne",
        "Toelichting": "CTR00"
    },
    {
        "Code": 190,
        "Waarde": "Chaam",
        "Toelichting": "CHA00"
    },
    {
        "Code": 191,
        "Waarde": "Charlois",
        "Toelichting": "CLS00"
    },
    {
        "Code": 192,
        "Waarde": "Clinge",
        "Toelichting": "CGE00"
    },
    {
        "Code": 193,
        "Waarde": "Coevorden",
        "Toelichting": "CVD00"
    },
    {
        "Code": 194,
        "Waarde": "Cothen",
        "Toelichting": "CTN00"
    },
    {
        "Code": 195,
        "Waarde": "Cuijk",
        "Toelichting": "CUI00"
    },
    {
        "Code": 196,
        "Waarde": "Culemborg",
        "Toelichting": "CLB00"
    },
    {
        "Code": 197,
        "Waarde": "Dalen",
        "Toelichting": "DLN00"
    },
    {
        "Code": 198,
        "Waarde": "Dalfsen",
        "Toelichting": "DSN01"
    },
    {
        "Code": 199,
        "Waarde": "De Bilt",
        "Toelichting": "BIL01"
    },
    {
        "Code": 200,
        "Waarde": "De Lier",
        "Toelichting": "LIE00"
    },
    {
        "Code": 201,
        "Waarde": "De Rijp",
        "Toelichting": "RIJ00"
    },
    {
        "Code": 202,
        "Waarde": "De Wijk",
        "Toelichting": "WIJ03"
    },
    {
        "Code": 203,
        "Waarde": "Deil",
        "Toelichting": "DEI00"
    },
    {
        "Code": 204,
        "Waarde": "Deinum",
        "Toelichting": "DNM00"
    },
    {
        "Code": 205,
        "Waarde": "Delfshaven",
        "Toelichting": "DHV00"
    },
    {
        "Code": 206,
        "Waarde": "Delft",
        "Toelichting": "DEL00"
    },
    {
        "Code": 207,
        "Waarde": "Delfzijl",
        "Toelichting": "DZL01"
    },
    {
        "Code": 208,
        "Waarde": "Den Bommel",
        "Toelichting": "BML03"
    },
    {
        "Code": 209,
        "Waarde": "Den Dungen",
        "Toelichting": "DGN02"
    },
    {
        "Code": 210,
        "Waarde": "Den Ham",
        "Toelichting": "HAM00"
    },
    {
        "Code": 211,
        "Waarde": "Den Helder",
        "Toelichting": "HDR00"
    },
    {
        "Code": 212,
        "Waarde": "Denekamp",
        "Toelichting": "DNK00"
    },
    {
        "Code": 213,
        "Waarde": "Deurne",
        "Toelichting": "DNE00"
    },
    {
        "Code": 214,
        "Waarde": "Deventer",
        "Toelichting": "DVT00"
    },
    {
        "Code": 215,
        "Waarde": "Didam",
        "Toelichting": "DDM00"
    },
    {
        "Code": 216,
        "Waarde": "Diemen",
        "Toelichting": "DMN00"
    },
    {
        "Code": 217,
        "Waarde": "Diepenheim",
        "Toelichting": "DPH00"
    },
    {
        "Code": 218,
        "Waarde": "Diepenveen",
        "Toelichting": "DPV00"
    },
    {
        "Code": 219,
        "Waarde": "Dieren",
        "Toelichting": "DRN00"
    },
    {
        "Code": 220,
        "Waarde": "Diessen",
        "Toelichting": "DSN02"
    },
    {
        "Code": 221,
        "Waarde": "Diever",
        "Toelichting": "DVR00"
    },
    {
        "Code": 222,
        "Waarde": "Dinteloord",
        "Toelichting": "DTO02"
    },
    {
        "Code": 223,
        "Waarde": "Dinxperlo",
        "Toelichting": "DPL00"
    },
    {
        "Code": 224,
        "Waarde": "Dirksland",
        "Toelichting": "DLD00"
    },
    {
        "Code": 225,
        "Waarde": "Dodewaard",
        "Toelichting": "DDW00"
    },
    {
        "Code": 226,
        "Waarde": "Doesburg",
        "Toelichting": "DBG02"
    },
    {
        "Code": 227,
        "Waarde": "Dokkum",
        "Toelichting": "DKM00"
    },
    {
        "Code": 228,
        "Waarde": "Domburg",
        "Toelichting": "DBG03"
    },
    {
        "Code": 229,
        "Waarde": "Dommelen",
        "Toelichting": "DML01"
    },
    {
        "Code": 230,
        "Waarde": "Dongen",
        "Toelichting": "DGN01"
    },
    {
        "Code": 231,
        "Waarde": "Donkerbroek",
        "Toelichting": "DKB00"
    },
    {
        "Code": 232,
        "Waarde": "Doorn",
        "Toelichting": "DOO00"
    },
    {
        "Code": 233,
        "Waarde": "Doornenburg",
        "Toelichting": "DNB00"
    },
    {
        "Code": 234,
        "Waarde": "Doornspijk",
        "Toelichting": "DSK00"
    },
    {
        "Code": 235,
        "Waarde": "Doorwerth",
        "Toelichting": "DWH00"
    },
    {
        "Code": 236,
        "Waarde": "Dordrecht",
        "Toelichting": "DDT00"
    },
    {
        "Code": 237,
        "Waarde": "Drachten",
        "Toelichting": "DTN02"
    },
    {
        "Code": 238,
        "Waarde": "Drechterland",
        "Toelichting": "DTL00"
    },
    {
        "Code": 239,
        "Waarde": "Dreumel",
        "Toelichting": "DML02"
    },
    {
        "Code": 240,
        "Waarde": "Driebergen-Rijsenburg",
        "Toelichting": "DBG01"
    },
    {
        "Code": 241,
        "Waarde": "Driel",
        "Toelichting": "DRI00"
    },
    {
        "Code": 242,
        "Waarde": "Drogeham",
        "Toelichting": "DGH00"
    },
    {
        "Code": 243,
        "Waarde": "Dronrijp",
        "Toelichting": "DRP00"
    },
    {
        "Code": 244,
        "Waarde": "Dronten",
        "Toelichting": "DTN01"
    },
    {
        "Code": 245,
        "Waarde": "Drunen",
        "Toelichting": "DNN00"
    },
    {
        "Code": 246,
        "Waarde": "Druten",
        "Toelichting": "DTN03"
    },
    {
        "Code": 247,
        "Waarde": "Dubbeldam",
        "Toelichting": "DBD00"
    },
    {
        "Code": 248,
        "Waarde": "Duiveland",
        "Toelichting": "DVL00"
    },
    {
        "Code": 249,
        "Waarde": "Duiven",
        "Toelichting": "DVN00"
    },
    {
        "Code": 250,
        "Waarde": "Duizel",
        "Toelichting": "DZL02"
    },
    {
        "Code": 251,
        "Waarde": "Dussen",
        "Toelichting": "DSN03"
    },
    {
        "Code": 252,
        "Waarde": "Duurswoude",
        "Toelichting": "DWD00"
    },
    {
        "Code": 253,
        "Waarde": "Dwingeloo",
        "Toelichting": "DGL00"
    },
    {
        "Code": 254,
        "Waarde": "Echt",
        "Toelichting": "ECH00"
    },
    {
        "Code": 255,
        "Waarde": "Echteld",
        "Toelichting": "ETD00"
    },
    {
        "Code": 256,
        "Waarde": "Eck en Wiel",
        "Toelichting": "ECK00"
    },
    {
        "Code": 257,
        "Waarde": "Edam",
        "Toelichting": "EDM00"
    },
    {
        "Code": 258,
        "Waarde": "Ede",
        "Toelichting": "EDE01"
    },
    {
        "Code": 259,
        "Waarde": "Ee",
        "Toelichting": "EEX00"
    },
    {
        "Code": 260,
        "Waarde": "Eelde",
        "Toelichting": "EDE02"
    },
    {
        "Code": 261,
        "Waarde": "Eemnes",
        "Toelichting": "ENS00"
    },
    {
        "Code": 262,
        "Waarde": "Eenrum",
        "Toelichting": "ERM00"
    },
    {
        "Code": 263,
        "Waarde": "Eersel",
        "Toelichting": "ESL00"
    },
    {
        "Code": 264,
        "Waarde": "Egmond aan Zee",
        "Toelichting": "EMD01"
    },
    {
        "Code": 265,
        "Waarde": "Egmond-Binnen",
        "Toelichting": "EMD02"
    },
    {
        "Code": 266,
        "Waarde": "Eibergen",
        "Toelichting": "EBG02"
    },
    {
        "Code": 267,
        "Waarde": "Eijsden",
        "Toelichting": "EDN00"
    },
    {
        "Code": 268,
        "Waarde": "Eindhoven",
        "Toelichting": "EHV00"
    },
    {
        "Code": 269,
        "Waarde": "Elburg",
        "Toelichting": "EBG01"
    },
    {
        "Code": 270,
        "Waarde": "Elsloo",
        "Toelichting": "ELO00"
    },
    {
        "Code": 271,
        "Waarde": "Elst",
        "Toelichting": "ELS00"
    },
    {
        "Code": 272,
        "Waarde": "Emmen",
        "Toelichting": "EMN00"
    },
    {
        "Code": 273,
        "Waarde": "Empel",
        "Toelichting": "EPL00"
    },
    {
        "Code": 274,
        "Waarde": "Enkhuizen",
        "Toelichting": "EHZ00"
    },
    {
        "Code": 275,
        "Waarde": "Enschede",
        "Toelichting": "ESD00"
    },
    {
        "Code": 276,
        "Waarde": "Epe en Oene",
        "Toelichting": "EPE00"
    },
    {
        "Code": 277,
        "Waarde": "Ermelo",
        "Toelichting": "EML00"
    },
    {
        "Code": 278,
        "Waarde": "Erp",
        "Toelichting": "ERP00"
    },
    {
        "Code": 279,
        "Waarde": "Esch",
        "Toelichting": "ESC00"
    },
    {
        "Code": 280,
        "Waarde": "Est en Opijnen",
        "Toelichting": "EST00"
    },
    {
        "Code": 281,
        "Waarde": "Etten",
        "Toelichting": "ETN02"
    },
    {
        "Code": 282,
        "Waarde": "Etten-Leur",
        "Toelichting": "ETN01"
    },
    {
        "Code": 283,
        "Waarde": "Everdingen",
        "Toelichting": "EVD00"
    },
    {
        "Code": 284,
        "Waarde": "Ewijk",
        "Toelichting": "EWK00"
    },
    {
        "Code": 285,
        "Waarde": "Eygelshoven",
        "Toelichting": "EGH00"
    },
    {
        "Code": 286,
        "Waarde": "Ezinge",
        "Toelichting": "EZG00"
    },
    {
        "Code": 287,
        "Waarde": "Ferwerd",
        "Toelichting": "FWD00"
    },
    {
        "Code": 288,
        "Waarde": "Fijnaart",
        "Toelichting": "FNT01"
    },
    {
        "Code": 289,
        "Waarde": "Finsterwolde",
        "Toelichting": "FSW00"
    },
    {
        "Code": 290,
        "Waarde": "Franeker",
        "Toelichting": "FNK00"
    },
    {
        "Code": 291,
        "Waarde": "Gaast",
        "Toelichting": "GAA00"
    },
    {
        "Code": 292,
        "Waarde": "Gameren",
        "Toelichting": "GMR00"
    },
    {
        "Code": 293,
        "Waarde": "Garderen",
        "Toelichting": "GDR03"
    },
    {
        "Code": 294,
        "Waarde": "Gassel",
        "Toelichting": "GSL02"
    },
    {
        "Code": 295,
        "Waarde": "Gasselte",
        "Toelichting": "GST00"
    },
    {
        "Code": 296,
        "Waarde": "Geertruidenberg",
        "Toelichting": "GTD01"
    },
    {
        "Code": 297,
        "Waarde": "Geervliet",
        "Toelichting": "GVT00"
    },
    {
        "Code": 298,
        "Waarde": "Geesteren",
        "Toelichting": "GTR00"
    },
    {
        "Code": 299,
        "Waarde": "Geffen",
        "Toelichting": "GFN00"
    },
    {
        "Code": 300,
        "Waarde": "Geldermalsen",
        "Toelichting": "GDM00"
    },
    {
        "Code": 301,
        "Waarde": "Geldrop",
        "Toelichting": "GDP00"
    },
    {
        "Code": 302,
        "Waarde": "Geleen",
        "Toelichting": "GLN00"
    },
    {
        "Code": 303,
        "Waarde": "Gemert",
        "Toelichting": "GMT00"
    },
    {
        "Code": 304,
        "Waarde": "Gendringen",
        "Toelichting": "GDG00"
    },
    {
        "Code": 305,
        "Waarde": "Gendt",
        "Toelichting": "GEN00"
    },
    {
        "Code": 306,
        "Waarde": "Genemuiden",
        "Toelichting": "GNM00"
    },
    {
        "Code": 307,
        "Waarde": "Gennep",
        "Toelichting": "GNP00"
    },
    {
        "Code": 308,
        "Waarde": "Gestel",
        "Toelichting": "GTL01"
    },
    {
        "Code": 309,
        "Waarde": "Geulle",
        "Toelichting": "GLE02"
    },
    {
        "Code": 310,
        "Waarde": "Giekerk",
        "Toelichting": "GKK02"
    },
    {
        "Code": 311,
        "Waarde": "Giessenburg",
        "Toelichting": "GSB00"
    },
    {
        "Code": 312,
        "Waarde": "Gieten",
        "Toelichting": "GTN00"
    },
    {
        "Code": 313,
        "Waarde": "Giethoorn",
        "Toelichting": "GHN00"
    },
    {
        "Code": 314,
        "Waarde": "Gilze en Rijen",
        "Toelichting": "GZE00"
    },
    {
        "Code": 315,
        "Waarde": "Ginneken",
        "Toelichting": "GNK02"
    },
    {
        "Code": 316,
        "Waarde": "Goedereede",
        "Toelichting": "GDR01"
    },
    {
        "Code": 317,
        "Waarde": "Goes",
        "Toelichting": "GOE00"
    },
    {
        "Code": 318,
        "Waarde": "Goirle",
        "Toelichting": "GLE01"
    },
    {
        "Code": 319,
        "Waarde": "Goor",
        "Toelichting": "GOO00"
    },
    {
        "Code": 320,
        "Waarde": "Gorinchem",
        "Toelichting": "GRC00"
    },
    {
        "Code": 321,
        "Waarde": "Gorredijk",
        "Toelichting": "GRD00"
    },
    {
        "Code": 322,
        "Waarde": "Gorssel",
        "Toelichting": "GSL01"
    },
    {
        "Code": 323,
        "Waarde": "Gouda",
        "Toelichting": "GDA01"
    },
    {
        "Code": 324,
        "Waarde": "Gouderak",
        "Toelichting": "GDR02"
    },
    {
        "Code": 325,
        "Waarde": "Goudriaan",
        "Toelichting": "GDA02"
    },
    {
        "Code": 326,
        "Waarde": "Goudswaard",
        "Toelichting": "GWD00"
    },
    {
        "Code": 327,
        "Waarde": "Graauw",
        "Toelichting": "GRA00"
    },
    {
        "Code": 328,
        "Waarde": "Grafhorst",
        "Toelichting": "GHT00"
    },
    {
        "Code": 329,
        "Waarde": "Graft",
        "Toelichting": "GRA02"
    },
    {
        "Code": 330,
        "Waarde": "Graft-De Rijp",
        "Toelichting": "GRA03"
    },
    {
        "Code": 331,
        "Waarde": "Gramsbergen",
        "Toelichting": "GBG00"
    },
    {
        "Code": 332,
        "Waarde": "Grathem",
        "Toelichting": "GTM00"
    },
    {
        "Code": 333,
        "Waarde": "Grave",
        "Toelichting": "GVE00"
    },
    {
        "Code": 334,
        "Waarde": "Grevenbicht",
        "Toelichting": "GVB00"
    },
    {
        "Code": 335,
        "Waarde": "Grijpskerk",
        "Toelichting": "GKK01"
    },
    {
        "Code": 336,
        "Waarde": "Groenlo",
        "Toelichting": "GLO00"
    },
    {
        "Code": 337,
        "Waarde": "Groesbeek",
        "Toelichting": "GBK00"
    },
    {
        "Code": 338,
        "Waarde": "Groessen en Loo",
        "Toelichting": "GSN00"
    },
    {
        "Code": 339,
        "Waarde": "Groningen",
        "Toelichting": "GNG00;GNG01"
    },
    {
        "Code": 340,
        "Waarde": "Gronsveld",
        "Toelichting": "GVD01"
    },
    {
        "Code": 341,
        "Waarde": "Groot-Ammers",
        "Toelichting": "AMS02"
    },
    {
        "Code": 342,
        "Waarde": "Grootebroek",
        "Toelichting": "GTB00"
    },
    {
        "Code": 343,
        "Waarde": "Grootegast",
        "Toelichting": "GTG00"
    },
    {
        "Code": 344,
        "Waarde": "Grouw",
        "Toelichting": "GRO00"
    },
    {
        "Code": 345,
        "Waarde": "Grubbenvorst",
        "Toelichting": "GBV00"
    },
    {
        "Code": 346,
        "Waarde": "Gulpen",
        "Toelichting": "GPN00"
    },
    {
        "Code": 347,
        "Waarde": "Haaften",
        "Toelichting": "HTN05"
    },
    {
        "Code": 348,
        "Waarde": "Haaksbergen",
        "Toelichting": "HBG01"
    },
    {
        "Code": 349,
        "Waarde": "Haaren",
        "Toelichting": "HRN02"
    },
    {
        "Code": 350,
        "Waarde": "Haarlem",
        "Toelichting": "HLM01;HLM02"
    },
    {
        "Code": 351,
        "Waarde": "Haarlemmerliede en Spaarnwoude",
        "Toelichting": "HLM04"
    },
    {
        "Code": 352,
        "Waarde": "Haarlemmermeer",
        "Toelichting": "HLM03"
    },
    {
        "Code": 353,
        "Waarde": "Haastrecht",
        "Toelichting": "HTT01"
    },
    {
        "Code": 354,
        "Waarde": "Haelen",
        "Toelichting": "HLN02"
    },
    {
        "Code": 355,
        "Waarde": "Hagestein",
        "Toelichting": "HGS00"
    },
    {
        "Code": 356,
        "Waarde": "Hall",
        "Toelichting": "HAL00"
    },
    {
        "Code": 357,
        "Waarde": "Hallum",
        "Toelichting": "HLM05"
    },
    {
        "Code": 358,
        "Waarde": "Halsteren",
        "Toelichting": "HSR00"
    },
    {
        "Code": 359,
        "Waarde": "Haps",
        "Toelichting": "HAP00"
    },
    {
        "Code": 360,
        "Waarde": "Hardegarijp",
        "Toelichting": "HDG00"
    },
    {
        "Code": 361,
        "Waarde": "Harderwijk",
        "Toelichting": "HDW00"
    },
    {
        "Code": 362,
        "Waarde": "Hardinxveld-Giessendam",
        "Toelichting": "HDV00"
    },
    {
        "Code": 363,
        "Waarde": "Haren",
        "Toelichting": "HRN01"
    },
    {
        "Code": 364,
        "Waarde": "Harenkarspel",
        "Toelichting": "HRK00"
    },
    {
        "Code": 365,
        "Waarde": "Harkstede",
        "Toelichting": "HSD02"
    },
    {
        "Code": 366,
        "Waarde": "Harlingen",
        "Toelichting": "HLG02"
    },
    {
        "Code": 367,
        "Waarde": "Harmelen",
        "Toelichting": "HML01"
    },
    {
        "Code": 368,
        "Waarde": "Hasselt",
        "Toelichting": "HST00"
    },
    {
        "Code": 369,
        "Waarde": "Hatert",
        "Toelichting": "HTT02"
    },
    {
        "Code": 370,
        "Waarde": "Hattem",
        "Toelichting": "HTM00"
    },
    {
        "Code": 371,
        "Waarde": "Havelte",
        "Toelichting": "HVT03"
    },
    {
        "Code": 372,
        "Waarde": "Hazerswoude",
        "Toelichting": "HZW00"
    },
    {
        "Code": 373,
        "Waarde": "Hedel",
        "Toelichting": "HDL01"
    },
    {
        "Code": 374,
        "Waarde": "Heeg",
        "Toelichting": "HEE04"
    },
    {
        "Code": 375,
        "Waarde": "Heel en Panheel",
        "Toelichting": "HEE01"
    },
    {
        "Code": 376,
        "Waarde": "Heemskerk",
        "Toelichting": "HKK01"
    },
    {
        "Code": 377,
        "Waarde": "Heemstede",
        "Toelichting": "HSD01"
    },
    {
        "Code": 378,
        "Waarde": "Heenvliet",
        "Toelichting": "HVT04"
    },
    {
        "Code": 379,
        "Waarde": "Heer",
        "Toelichting": "HEE03"
    },
    {
        "Code": 380,
        "Waarde": "Heerde",
        "Toelichting": "HDE00"
    },
    {
        "Code": 381,
        "Waarde": "Heerenveen",
        "Toelichting": "HRV01"
    },
    {
        "Code": 382,
        "Waarde": "Heerewaarden",
        "Toelichting": "HRW00"
    },
    {
        "Code": 383,
        "Waarde": "Heerhugowaard",
        "Toelichting": "HHG00"
    },
    {
        "Code": 384,
        "Waarde": "Heerjansdam",
        "Toelichting": "HJD00"
    },
    {
        "Code": 385,
        "Waarde": "Heerlen",
        "Toelichting": "HLN01"
    },
    {
        "Code": 386,
        "Waarde": "Heesch",
        "Toelichting": "HEE02"
    },
    {
        "Code": 387,
        "Waarde": "Heeswijk-Dinther",
        "Toelichting": "HWK02"
    },
    {
        "Code": 388,
        "Waarde": "Heeze",
        "Toelichting": "HZE00"
    },
    {
        "Code": 389,
        "Waarde": "Hei- en Boeicop",
        "Toelichting": "HEI00"
    },
    {
        "Code": 390,
        "Waarde": "Heiloo",
        "Toelichting": "HLO00"
    },
    {
        "Code": 391,
        "Waarde": "Heinenoord",
        "Toelichting": "HNO02"
    },
    {
        "Code": 392,
        "Waarde": "Heino",
        "Toelichting": "HNO01"
    },
    {
        "Code": 393,
        "Waarde": "Hekendorp",
        "Toelichting": "HKD00"
    },
    {
        "Code": 394,
        "Waarde": "Helden",
        "Toelichting": "HDN01"
    },
    {
        "Code": 395,
        "Waarde": "Hellendoorn",
        "Toelichting": "HLD01"
    },
    {
        "Code": 396,
        "Waarde": "Hellevoetsluis",
        "Toelichting": "HLV01"
    },
    {
        "Code": 397,
        "Waarde": "Helmond",
        "Toelichting": "HMD00"
    },
    {
        "Code": 398,
        "Waarde": "Helpman",
        "Toelichting": "HMN02"
    },
    {
        "Code": 399,
        "Waarde": "Helvoirt",
        "Toelichting": "HVT02"
    },
    {
        "Code": 400,
        "Waarde": "Hendrik-Ido-Ambacht",
        "Toelichting": "HDK03"
    },
    {
        "Code": 401,
        "Waarde": "Hengelo Gelderland",
        "Toelichting": "HGL02"
    },
    {
        "Code": 402,
        "Waarde": "Hengelo Overijssel",
        "Toelichting": "HGL01"
    },
    {
        "Code": 403,
        "Waarde": "Herkingen",
        "Toelichting": "HKG00"
    },
    {
        "Code": 404,
        "Waarde": "Hernen",
        "Toelichting": "HNN00"
    },
    {
        "Code": 405,
        "Waarde": "Herten",
        "Toelichting": "HTN02"
    },
    {
        "Code": 406,
        "Waarde": "Herwen",
        "Toelichting": "HWN01"
    },
    {
        "Code": 407,
        "Waarde": "Herwijnen",
        "Toelichting": "HWN02"
    },
    {
        "Code": 408,
        "Waarde": "Heteren",
        "Toelichting": "HTR00"
    },
    {
        "Code": 409,
        "Waarde": "Heukelum",
        "Toelichting": "HKL00"
    },
    {
        "Code": 410,
        "Waarde": "Heumen",
        "Toelichting": "HMN01"
    },
    {
        "Code": 411,
        "Waarde": "Heusden",
        "Toelichting": "HDN02"
    },
    {
        "Code": 412,
        "Waarde": "Heythuysen",
        "Toelichting": "HHS00"
    },
    {
        "Code": 413,
        "Waarde": "Hien",
        "Toelichting": "HIE00"
    },
    {
        "Code": 414,
        "Waarde": "Hijum",
        "Toelichting": "HUM00"
    },
    {
        "Code": 415,
        "Waarde": "Hillegersberg",
        "Toelichting": "HLG03"
    },
    {
        "Code": 416,
        "Waarde": "Hillegom",
        "Toelichting": "HLG01"
    },
    {
        "Code": 417,
        "Waarde": "Hilvarenbeek",
        "Toelichting": "HVR00"
    },
    {
        "Code": 418,
        "Waarde": "Hilversum",
        "Toelichting": "HVS00"
    },
    {
        "Code": 419,
        "Waarde": "Hindeloopen",
        "Toelichting": "HDL02"
    },
    {
        "Code": 420,
        "Waarde": "Hoek",
        "Toelichting": "HOE02"
    },
    {
        "Code": 421,
        "Waarde": "Hoek van Holland",
        "Toelichting": "HOE01"
    },
    {
        "Code": 422,
        "Waarde": "Hoensbroek",
        "Toelichting": "HBK00"
    },
    {
        "Code": 423,
        "Waarde": "Hoevelaken",
        "Toelichting": "HVL00"
    },
    {
        "Code": 424,
        "Waarde": "Hoeven",
        "Toelichting": "HVN00"
    },
    {
        "Code": 425,
        "Waarde": "Holten",
        "Toelichting": "HTN03"
    },
    {
        "Code": 426,
        "Waarde": "Holwerd",
        "Toelichting": "HWD00"
    },
    {
        "Code": 427,
        "Waarde": "Hontenisse",
        "Toelichting": "HTN01"
    },
    {
        "Code": 428,
        "Waarde": "Hoog Soeren",
        "Toelichting": "SRN00"
    },
    {
        "Code": 429,
        "Waarde": "Hoogblokland",
        "Toelichting": "HBL00"
    },
    {
        "Code": 430,
        "Waarde": "Hooge en Lage Mierde",
        "Toelichting": "MDE02"
    },
    {
        "Code": 431,
        "Waarde": "Hooge en Lage Zwaluwe",
        "Toelichting": "ZLW00"
    },
    {
        "Code": 432,
        "Waarde": "Hoogeloon",
        "Toelichting": "HGL04"
    },
    {
        "Code": 433,
        "Waarde": "Hoogeveen",
        "Toelichting": "HGV00"
    },
    {
        "Code": 434,
        "Waarde": "Hoogezand",
        "Toelichting": "HGZ00"
    },
    {
        "Code": 435,
        "Waarde": "Hoogkarspel",
        "Toelichting": "HKS00"
    },
    {
        "Code": 436,
        "Waarde": "Hoogkerk",
        "Toelichting": "HKK02"
    },
    {
        "Code": 437,
        "Waarde": "Hoogland",
        "Toelichting": "HLD02"
    },
    {
        "Code": 438,
        "Waarde": "Hoogvliet",
        "Toelichting": "HVT01"
    },
    {
        "Code": 439,
        "Waarde": "Hoorn",
        "Toelichting": "HOO00"
    },
    {
        "Code": 440,
        "Waarde": "Hoornaar",
        "Toelichting": "HNR00"
    },
    {
        "Code": 441,
        "Waarde": "Horn",
        "Toelichting": "HOR02"
    },
    {
        "Code": 442,
        "Waarde": "Horssen",
        "Toelichting": "HSN02"
    },
    {
        "Code": 443,
        "Waarde": "Horst",
        "Toelichting": "HOR01"
    },
    {
        "Code": 444,
        "Waarde": "Houten",
        "Toelichting": "HTN04"
    },
    {
        "Code": 445,
        "Waarde": "Houthem",
        "Toelichting": "HHM00"
    },
    {
        "Code": 446,
        "Waarde": "Huijbergen",
        "Toelichting": "HBG03"
    },
    {
        "Code": 447,
        "Waarde": "Huissen",
        "Toelichting": "HSN01"
    },
    {
        "Code": 448,
        "Waarde": "Huizen",
        "Toelichting": "HZN00"
    },
    {
        "Code": 449,
        "Waarde": "Huizum",
        "Toelichting": "HZM00"
    },
    {
        "Code": 450,
        "Waarde": "Hulsberg",
        "Toelichting": "HBG02"
    },
    {
        "Code": 451,
        "Waarde": "Hulst",
        "Toelichting": "HUL00"
    },
    {
        "Code": 452,
        "Waarde": "Hummelo",
        "Toelichting": "HML02"
    },
    {
        "Code": 453,
        "Waarde": "Hunsel",
        "Toelichting": "HSL00"
    },
    {
        "Code": 454,
        "Waarde": "IJlst",
        "Toelichting": "IJL00"
    },
    {
        "Code": 455,
        "Waarde": "IJmuiden",
        "Toelichting": "IMD00"
    },
    {
        "Code": 456,
        "Waarde": "IJsselham",
        "Toelichting": "ISH00"
    },
    {
        "Code": 457,
        "Waarde": "IJsselmeer",
        "Toelichting": "ISM03"
    },
    {
        "Code": 458,
        "Waarde": "IJsselmeer-west",
        "Toelichting": "ISM04"
    },
    {
        "Code": 459,
        "Waarde": "IJsselmonde",
        "Toelichting": "ISM01"
    },
    {
        "Code": 460,
        "Waarde": "IJsselmuiden",
        "Toelichting": "ISM02"
    },
    {
        "Code": 461,
        "Waarde": "IJsselstein",
        "Toelichting": "ISS00"
    },
    {
        "Code": 462,
        "Waarde": "Ilpendam",
        "Toelichting": "IPD00"
    },
    {
        "Code": 463,
        "Waarde": "Ingen",
        "Toelichting": "IGN00"
    },
    {
        "Code": 464,
        "Waarde": "Itteren",
        "Toelichting": "ITR00"
    },
    {
        "Code": 465,
        "Waarde": "Ittervoort",
        "Toelichting": "ITV00"
    },
    {
        "Code": 466,
        "Waarde": "Jaarsveld",
        "Toelichting": "JVD00"
    },
    {
        "Code": 467,
        "Waarde": "Jabeek",
        "Toelichting": "JBK00"
    },
    {
        "Code": 468,
        "Waarde": "Jelsum",
        "Toelichting": "JSM00"
    },
    {
        "Code": 469,
        "Waarde": "Jisp",
        "Toelichting": "JIS00"
    },
    {
        "Code": 470,
        "Waarde": "Jorwerd",
        "Toelichting": "JWD00"
    },
    {
        "Code": 471,
        "Waarde": "Joure",
        "Toelichting": "JRE00"
    },
    {
        "Code": 472,
        "Waarde": "Jutphaas",
        "Toelichting": "JPS00"
    },
    {
        "Code": 473,
        "Waarde": "Kamerik",
        "Toelichting": "KMR00"
    },
    {
        "Code": 474,
        "Waarde": "Kampen",
        "Toelichting": "KPN01"
    },
    {
        "Code": 475,
        "Waarde": "Kantens",
        "Toelichting": "KTS00"
    },
    {
        "Code": 476,
        "Waarde": "Kapelle",
        "Toelichting": "KPL01"
    },
    {
        "Code": 477,
        "Waarde": "Kattendijke",
        "Toelichting": "KTD00"
    },
    {
        "Code": 478,
        "Waarde": "Katwijk",
        "Toelichting": "KWK01"
    },
    {
        "Code": 479,
        "Waarde": "Katwoude",
        "Toelichting": "KWD00"
    },
    {
        "Code": 480,
        "Waarde": "Kedichem",
        "Toelichting": "KDC00"
    },
    {
        "Code": 481,
        "Waarde": "Keppel",
        "Toelichting": "KPL02"
    },
    {
        "Code": 482,
        "Waarde": "Kerkrade",
        "Toelichting": "KRD00"
    },
    {
        "Code": 483,
        "Waarde": "Kerkwijk",
        "Toelichting": "KWK02"
    },
    {
        "Code": 484,
        "Waarde": "Kessel",
        "Toelichting": "KSL00"
    },
    {
        "Code": 485,
        "Waarde": "Kesteren",
        "Toelichting": "KTR00"
    },
    {
        "Code": 486,
        "Waarde": "Klaaswaal",
        "Toelichting": "KWL00"
    },
    {
        "Code": 487,
        "Waarde": "Klimmen",
        "Toelichting": "KMN02"
    },
    {
        "Code": 488,
        "Waarde": "Kloetinge",
        "Toelichting": "KTG00"
    },
    {
        "Code": 489,
        "Waarde": "Kloosterburen",
        "Toelichting": "KTB00"
    },
    {
        "Code": 490,
        "Waarde": "Klundert",
        "Toelichting": "KDT00"
    },
    {
        "Code": 491,
        "Waarde": "Knijpe",
        "Toelichting": "KPE00"
    },
    {
        "Code": 492,
        "Waarde": "Kockengen",
        "Toelichting": "KKG00"
    },
    {
        "Code": 493,
        "Waarde": "Kollum",
        "Toelichting": "KLM00"
    },
    {
        "Code": 494,
        "Waarde": "Koog aan de Zaan",
        "Toelichting": "KOO00"
    },
    {
        "Code": 495,
        "Waarde": "Kooten",
        "Toelichting": "KTN00"
    },
    {
        "Code": 496,
        "Waarde": "Kortenhoef",
        "Toelichting": "KTH00"
    },
    {
        "Code": 497,
        "Waarde": "Kortgene",
        "Toelichting": "KGN00"
    },
    {
        "Code": 498,
        "Waarde": "Koudekerk aan den Rijn",
        "Toelichting": "KDK02"
    },
    {
        "Code": 499,
        "Waarde": "Koudum",
        "Toelichting": "KDM00"
    },
    {
        "Code": 500,
        "Waarde": "Krabbendijke",
        "Toelichting": "KBD00"
    },
    {
        "Code": 501,
        "Waarde": "Kralingen",
        "Toelichting": "KLG00"
    },
    {
        "Code": 502,
        "Waarde": "Krimpen aan de Lek",
        "Toelichting": "KPN03"
    },
    {
        "Code": 503,
        "Waarde": "Krimpen aan den IJssel",
        "Toelichting": "KPN02"
    },
    {
        "Code": 504,
        "Waarde": "Kring van Dorth",
        "Toelichting": "KRI00"
    },
    {
        "Code": 505,
        "Waarde": "Krommenie",
        "Toelichting": "KMN01"
    },
    {
        "Code": 506,
        "Waarde": "Kruiningen",
        "Toelichting": "KNG00"
    },
    {
        "Code": 507,
        "Waarde": "Kuinre",
        "Toelichting": "KRE00"
    },
    {
        "Code": 508,
        "Waarde": "Kwadijk",
        "Toelichting": "KDK01"
    },
    {
        "Code": 509,
        "Waarde": "Laag Nieuwkoop",
        "Toelichting": "NKP02"
    },
    {
        "Code": 510,
        "Waarde": "Landgraaf",
        "Toelichting": "LGF00"
    },
    {
        "Code": 511,
        "Waarde": "Landsmeer",
        "Toelichting": "LMR02"
    },
    {
        "Code": 512,
        "Waarde": "Langbroek",
        "Toelichting": "LBK02"
    },
    {
        "Code": 513,
        "Waarde": "Lange Ruige Weide",
        "Toelichting": "WDE02"
    },
    {
        "Code": 514,
        "Waarde": "Langedijk",
        "Toelichting": "LGD00"
    },
    {
        "Code": 515,
        "Waarde": "Langerak",
        "Toelichting": "LGR00"
    },
    {
        "Code": 516,
        "Waarde": "Langezwaag",
        "Toelichting": "LGZ00"
    },
    {
        "Code": 517,
        "Waarde": "Langweer",
        "Toelichting": "LWR02"
    },
    {
        "Code": 518,
        "Waarde": "Laren Noord-Holland",
        "Toelichting": "LRN01"
    },
    {
        "Code": 519,
        "Waarde": "Laren Gelderland",
        "Toelichting": "LRN02"
    },
    {
        "Code": 520,
        "Waarde": "Laren-Verwolde",
        "Toelichting": "LRN03"
    },
    {
        "Code": 521,
        "Waarde": "Lauwerecht",
        "Toelichting": "LWR01"
    },
    {
        "Code": 522,
        "Waarde": "Leek",
        "Toelichting": "LEE01"
    },
    {
        "Code": 523,
        "Waarde": "Leende",
        "Toelichting": "LDE01"
    },
    {
        "Code": 524,
        "Waarde": "Leens",
        "Toelichting": "LEE02"
    },
    {
        "Code": 525,
        "Waarde": "Leerbroek",
        "Toelichting": "LBK01"
    },
    {
        "Code": 526,
        "Waarde": "Leerdam",
        "Toelichting": "LDM00"
    },
    {
        "Code": 527,
        "Waarde": "Leersum",
        "Toelichting": "LSM00"
    },
    {
        "Code": 528,
        "Waarde": "Leeuwarden",
        "Toelichting": "LWD00"
    },
    {
        "Code": 529,
        "Waarde": "Leeuwen",
        "Toelichting": "LWN00"
    },
    {
        "Code": 530,
        "Waarde": "Leiden",
        "Toelichting": "LDN01"
    },
    {
        "Code": 531,
        "Waarde": "Leiderdorp",
        "Toelichting": "LDD00"
    },
    {
        "Code": 532,
        "Waarde": "Leimuiden",
        "Toelichting": "LMD02"
    },
    {
        "Code": 533,
        "Waarde": "Lekkerkerk",
        "Toelichting": "LKK00"
    },
    {
        "Code": 534,
        "Waarde": "Lelystad",
        "Toelichting": "LLS00"
    },
    {
        "Code": 535,
        "Waarde": "Lemmer",
        "Toelichting": "LMR01"
    },
    {
        "Code": 536,
        "Waarde": "Lent",
        "Toelichting": "LEN00"
    },
    {
        "Code": 537,
        "Waarde": "Leusden",
        "Toelichting": "LDN02"
    },
    {
        "Code": 538,
        "Waarde": "Leuth",
        "Toelichting": "LEU00"
    },
    {
        "Code": 539,
        "Waarde": "Lexmond",
        "Toelichting": "LMD01"
    },
    {
        "Code": 540,
        "Waarde": "Lichtenvoorde",
        "Toelichting": "LTV00"
    },
    {
        "Code": 541,
        "Waarde": "Liempde",
        "Toelichting": "LDE02"
    },
    {
        "Code": 542,
        "Waarde": "Lienden",
        "Toelichting": "LDN04"
    },
    {
        "Code": 543,
        "Waarde": "Lierop",
        "Toelichting": "LRP00"
    },
    {
        "Code": 544,
        "Waarde": "Lieshout",
        "Toelichting": "LHT00"
    },
    {
        "Code": 545,
        "Waarde": "Lieve Vrouwe Parochie",
        "Toelichting": "VWE00"
    },
    {
        "Code": 546,
        "Waarde": "Limbricht",
        "Toelichting": "LBT00"
    },
    {
        "Code": 547,
        "Waarde": "Limmen",
        "Toelichting": "LMN00"
    },
    {
        "Code": 548,
        "Waarde": "Linne",
        "Toelichting": "LNE00"
    },
    {
        "Code": 549,
        "Waarde": "Linschoten",
        "Toelichting": "LST00"
    },
    {
        "Code": 550,
        "Waarde": "Lippenhuizen",
        "Toelichting": "LPH00"
    },
    {
        "Code": 551,
        "Waarde": "Lisse",
        "Toelichting": "LSE00"
    },
    {
        "Code": 552,
        "Waarde": "Lith",
        "Toelichting": "LIT00"
    },
    {
        "Code": 553,
        "Waarde": "Lithoijen",
        "Toelichting": "LHE00"
    },
    {
        "Code": 554,
        "Waarde": "Lobith en Spijk",
        "Toelichting": "LBH00"
    },
    {
        "Code": 555,
        "Waarde": "Lochem",
        "Toelichting": "LCM00"
    },
    {
        "Code": 556,
        "Waarde": "Loenen",
        "Toelichting": "LNN00"
    },
    {
        "Code": 557,
        "Waarde": "Loenersloot",
        "Toelichting": "LNS00"
    },
    {
        "Code": 558,
        "Waarde": "Lonneker",
        "Toelichting": "LNK00"
    },
    {
        "Code": 559,
        "Waarde": "Loon op Zand",
        "Toelichting": "LOO00"
    },
    {
        "Code": 560,
        "Waarde": "Loosdrecht",
        "Toelichting": "LDT00"
    },
    {
        "Code": 561,
        "Waarde": "Loosduinen",
        "Toelichting": "LDN03"
    },
    {
        "Code": 562,
        "Waarde": "Lopik",
        "Toelichting": "LPK00"
    },
    {
        "Code": 563,
        "Waarde": "Loppersum",
        "Toelichting": "LPS00"
    },
    {
        "Code": 564,
        "Waarde": "Losser",
        "Toelichting": "LSR00"
    },
    {
        "Code": 565,
        "Waarde": "Lunteren",
        "Toelichting": "LTR00"
    },
    {
        "Code": 566,
        "Waarde": "Luyksgestel",
        "Toelichting": "LGT00"
    },
    {
        "Code": 567,
        "Waarde": "Maarheeze",
        "Toelichting": "MHZ00"
    },
    {
        "Code": 568,
        "Waarde": "Maarn",
        "Toelichting": "MAA00"
    },
    {
        "Code": 569,
        "Waarde": "Maarsseveen",
        "Toelichting": "MSV00"
    },
    {
        "Code": 570,
        "Waarde": "Maarssen",
        "Toelichting": "MSN02"
    },
    {
        "Code": 571,
        "Waarde": "Maartensdijk",
        "Toelichting": "MTD02"
    },
    {
        "Code": 572,
        "Waarde": "Maasbommel",
        "Toelichting": "MBM00"
    },
    {
        "Code": 573,
        "Waarde": "Maasbracht",
        "Toelichting": "MBT00"
    },
    {
        "Code": 574,
        "Waarde": "Maasbree",
        "Toelichting": "MBE00"
    },
    {
        "Code": 575,
        "Waarde": "Maasdam",
        "Toelichting": "MDM01"
    },
    {
        "Code": 576,
        "Waarde": "Maasdriel",
        "Toelichting": "MDL01"
    },
    {
        "Code": 577,
        "Waarde": "Maashees",
        "Toelichting": "MHS00"
    },
    {
        "Code": 578,
        "Waarde": "Maasland",
        "Toelichting": "MLD00"
    },
    {
        "Code": 579,
        "Waarde": "Maasniel",
        "Toelichting": "MNL00"
    },
    {
        "Code": 580,
        "Waarde": "Maassluis",
        "Toelichting": "MSS00"
    },
    {
        "Code": 581,
        "Waarde": "Maastricht",
        "Toelichting": "MTT00"
    },
    {
        "Code": 582,
        "Waarde": "Made en Drimmelen",
        "Toelichting": "MDE01"
    },
    {
        "Code": 583,
        "Waarde": "Makkinga",
        "Toelichting": "MKG00"
    },
    {
        "Code": 584,
        "Waarde": "Makkum",
        "Toelichting": "MKM00"
    },
    {
        "Code": 585,
        "Waarde": "Margraten",
        "Toelichting": "MGT02"
    },
    {
        "Code": 586,
        "Waarde": "Mariekerke",
        "Toelichting": "MRK02"
    },
    {
        "Code": 587,
        "Waarde": "Markelo",
        "Toelichting": "MKL00"
    },
    {
        "Code": 588,
        "Waarde": "Marken",
        "Toelichting": "MKN00"
    },
    {
        "Code": 589,
        "Waarde": "Markermeer",
        "Toelichting": "MKM01"
    },
    {
        "Code": 590,
        "Waarde": "Marrum",
        "Toelichting": "MRM02"
    },
    {
        "Code": 591,
        "Waarde": "Marum",
        "Toelichting": "MRM01"
    },
    {
        "Code": 592,
        "Waarde": "Maurik",
        "Toelichting": "MRK01"
    },
    {
        "Code": 593,
        "Waarde": "Medemblik",
        "Toelichting": "MDB02"
    },
    {
        "Code": 594,
        "Waarde": "Meeden",
        "Toelichting": "MDN02"
    },
    {
        "Code": 595,
        "Waarde": "Meerkerk",
        "Toelichting": "MKK00"
    },
    {
        "Code": 596,
        "Waarde": "Meerlo",
        "Toelichting": "MLO02"
    },
    {
        "Code": 597,
        "Waarde": "Meerssen",
        "Toelichting": "MSN01"
    },
    {
        "Code": 598,
        "Waarde": "Megen",
        "Toelichting": "MGN02"
    },
    {
        "Code": 599,
        "Waarde": "Meijel",
        "Toelichting": "MEL00"
    },
    {
        "Code": 600,
        "Waarde": "Melick en Herkenbosch",
        "Toelichting": "MLK00"
    },
    {
        "Code": 601,
        "Waarde": "Melissant",
        "Toelichting": "MLS00"
    },
    {
        "Code": 602,
        "Waarde": "Meppel",
        "Toelichting": "MPL00"
    },
    {
        "Code": 603,
        "Waarde": "Merkelbeek",
        "Toelichting": "MKB00"
    },
    {
        "Code": 604,
        "Waarde": "Mesch",
        "Toelichting": "MES00"
    },
    {
        "Code": 605,
        "Waarde": "Mheer",
        "Toelichting": "MHE00"
    },
    {
        "Code": 606,
        "Waarde": "Middelburg",
        "Toelichting": "MDB01"
    },
    {
        "Code": 607,
        "Waarde": "Middelharnis",
        "Toelichting": "MDH00"
    },
    {
        "Code": 608,
        "Waarde": "Middelie",
        "Toelichting": "MDL02"
    },
    {
        "Code": 609,
        "Waarde": "Middelstum",
        "Toelichting": "MDS02"
    },
    {
        "Code": 610,
        "Waarde": "Middenschouwen",
        "Toelichting": "MDS01"
    },
    {
        "Code": 611,
        "Waarde": "Midwolda",
        "Toelichting": "MWD01"
    },
    {
        "Code": 612,
        "Waarde": "Midwoud",
        "Toelichting": "MWD02"
    },
    {
        "Code": 613,
        "Waarde": "Mierlo",
        "Toelichting": "MLO01"
    },
    {
        "Code": 614,
        "Waarde": "Mijdrecht",
        "Toelichting": "MDT01"
    },
    {
        "Code": 615,
        "Waarde": "Mijnsheerenland",
        "Toelichting": "MHR00"
    },
    {
        "Code": 616,
        "Waarde": "Mildam",
        "Toelichting": "MDM02"
    },
    {
        "Code": 617,
        "Waarde": "Mill",
        "Toelichting": "MIL00"
    },
    {
        "Code": 618,
        "Waarde": "Millingen",
        "Toelichting": "MLG00"
    },
    {
        "Code": 619,
        "Waarde": "Minnertsga",
        "Toelichting": "MGN01"
    },
    {
        "Code": 620,
        "Waarde": "Moergestel",
        "Toelichting": "MGT01"
    },
    {
        "Code": 621,
        "Waarde": "Moerkapelle",
        "Toelichting": "MKP00"
    },
    {
        "Code": 622,
        "Waarde": "Molenaarsgraaf",
        "Toelichting": "MLN00"
    },
    {
        "Code": 623,
        "Waarde": "Monnickendam",
        "Toelichting": "MNK00"
    },
    {
        "Code": 624,
        "Waarde": "Monster",
        "Toelichting": "MSR00"
    },
    {
        "Code": 625,
        "Waarde": "Montfoort",
        "Toelichting": "MFT01"
    },
    {
        "Code": 626,
        "Waarde": "Montfort",
        "Toelichting": "MFT02"
    },
    {
        "Code": 627,
        "Waarde": "Mook en Middelaar",
        "Toelichting": "MOO00"
    },
    {
        "Code": 628,
        "Waarde": "Moordrecht",
        "Toelichting": "MDT02"
    },
    {
        "Code": 629,
        "Waarde": "Muiden",
        "Toelichting": "MDN01"
    },
    {
        "Code": 630,
        "Waarde": "Munstergeleen",
        "Toelichting": "MSG00"
    },
    {
        "Code": 631,
        "Waarde": "Muntendam",
        "Toelichting": "MTD01"
    },
    {
        "Code": 632,
        "Waarde": "Naaldwijk",
        "Toelichting": "NWK01"
    },
    {
        "Code": 633,
        "Waarde": "Naarden",
        "Toelichting": "NDN00"
    },
    {
        "Code": 634,
        "Waarde": "Nederasselt",
        "Toelichting": "NDA00"
    },
    {
        "Code": 635,
        "Waarde": "Nederhemert",
        "Toelichting": "NDH02"
    },
    {
        "Code": 636,
        "Waarde": "Nederhorst den Berg",
        "Toelichting": "NDH01"
    },
    {
        "Code": 637,
        "Waarde": "Nederweert",
        "Toelichting": "NDW00"
    },
    {
        "Code": 638,
        "Waarde": "Neede",
        "Toelichting": "NDE00"
    },
    {
        "Code": 639,
        "Waarde": "Neer",
        "Toelichting": "NEE00"
    },
    {
        "Code": 640,
        "Waarde": "Neerbosch",
        "Toelichting": "NBH00"
    },
    {
        "Code": 641,
        "Waarde": "Neeritter",
        "Toelichting": "NIT00"
    },
    {
        "Code": 642,
        "Waarde": "Nes",
        "Toelichting": "NES02"
    },
    {
        "Code": 643,
        "Waarde": "Netwerken Alkmaar",
        "Toelichting": "NWK24"
    },
    {
        "Code": 644,
        "Waarde": "Netwerken Amsterdam",
        "Toelichting": "NWK14"
    },
    {
        "Code": 645,
        "Waarde": "Netwerken Arnhem",
        "Toelichting": "NWK25"
    },
    {
        "Code": 646,
        "Waarde": "Netwerken Assen",
        "Toelichting": "NWK21"
    },
    {
        "Code": 647,
        "Waarde": "Netwerken Breda",
        "Toelichting": "NWK13"
    },
    {
        "Code": 648,
        "Waarde": "Netwerken Eindhoven",
        "Toelichting": "NWK19"
    },
    {
        "Code": 649,
        "Waarde": "Netwerken Groningen",
        "Toelichting": "NWK22"
    },
    {
        "Code": 650,
        "Waarde": "Netwerken Leeuwarden",
        "Toelichting": "NWK20"
    },
    {
        "Code": 651,
        "Waarde": "Netwerken Lelystad",
        "Toelichting": "NWK26"
    },
    {
        "Code": 652,
        "Waarde": "Netwerken Middelburg",
        "Toelichting": "NWK12"
    },
    {
        "Code": 653,
        "Waarde": "Netwerken Roermond",
        "Toelichting": "NWK18"
    },
    {
        "Code": 654,
        "Waarde": "Netwerken Rotterdam",
        "Toelichting": "NWK15"
    },
    {
        "Code": 655,
        "Waarde": "Netwerken",
        "Toelichting": "NWK17"
    },
    {
        "Code": 656,
        "Waarde": "Netwerken Zoetermeer",
        "Toelichting": "NWK16"
    },
    {
        "Code": 657,
        "Waarde": "Netwerken Zwolle",
        "Toelichting": "NWK23"
    },
    {
        "Code": 658,
        "Waarde": "Nibbixwoud",
        "Toelichting": "NBW00"
    },
    {
        "Code": 659,
        "Waarde": "Niedorp",
        "Toelichting": "NDP02"
    },
    {
        "Code": 660,
        "Waarde": "Nieuw-Beijerland",
        "Toelichting": "BEL03"
    },
    {
        "Code": 661,
        "Waarde": "Nieuwe Pekela",
        "Toelichting": "PKL01"
    },
    {
        "Code": 662,
        "Waarde": "Nieuwe Tonge",
        "Toelichting": "TGE00"
    },
    {
        "Code": 663,
        "Waarde": "Nieuwendam",
        "Toelichting": "NWD01"
    },
    {
        "Code": 664,
        "Waarde": "Nieuwenhagen",
        "Toelichting": "NWH01"
    },
    {
        "Code": 665,
        "Waarde": "Nieuwenhoorn",
        "Toelichting": "NWH02"
    },
    {
        "Code": 666,
        "Waarde": "Nieuwerkerk aan den IJssel",
        "Toelichting": "NWK03"
    },
    {
        "Code": 667,
        "Waarde": "Nieuweschans",
        "Toelichting": "NWS00"
    },
    {
        "Code": 668,
        "Waarde": "Nieuw-Ginneken",
        "Toelichting": "GNK01"
    },
    {
        "Code": 669,
        "Waarde": "Nieuw-Helvoet",
        "Toelichting": "HLV02"
    },
    {
        "Code": 670,
        "Waarde": "Nieuwkoop",
        "Toelichting": "NKP01"
    },
    {
        "Code": 671,
        "Waarde": "Nieuwland Friesland",
        "Toelichting": "NLD01"
    },
    {
        "Code": 672,
        "Waarde": "Nieuwland Zuid-Holland",
        "Toelichting": "NLD02"
    },
    {
        "Code": 673,
        "Waarde": "Nieuw-Lekkerland",
        "Toelichting": "LKL00"
    },
    {
        "Code": 674,
        "Waarde": "Nieuwleusen",
        "Toelichting": "NLS00"
    },
    {
        "Code": 675,
        "Waarde": "Nieuwolda",
        "Toelichting": "NWD03"
    },
    {
        "Code": 676,
        "Waarde": "Nieuwpoort",
        "Toelichting": "NPT00"
    },
    {
        "Code": 677,
        "Waarde": "Nieuwstadt",
        "Toelichting": "NST02"
    },
    {
        "Code": 678,
        "Waarde": "Nieuwveen",
        "Toelichting": "NVN00"
    },
    {
        "Code": 679,
        "Waarde": "Nieuw-Vossemeer",
        "Toelichting": "VSM02"
    },
    {
        "Code": 680,
        "Waarde": "Niftrik",
        "Toelichting": "NTK00"
    },
    {
        "Code": 681,
        "Waarde": "Nigtevecht",
        "Toelichting": "NTV00"
    },
    {
        "Code": 682,
        "Waarde": "Nijbroek",
        "Toelichting": "NBK02"
    },
    {
        "Code": 683,
        "Waarde": "Nijehaske",
        "Toelichting": "NEK00"
    },
    {
        "Code": 684,
        "Waarde": "Nijeveen",
        "Toelichting": "NEV00"
    },
    {
        "Code": 685,
        "Waarde": "Nijkerk Gelderland",
        "Toelichting": "NKK01"
    },
    {
        "Code": 686,
        "Waarde": "Nijkerk Friesland",
        "Toelichting": "NKK02"
    },
    {
        "Code": 687,
        "Waarde": "Nijmegen",
        "Toelichting": "NMG00"
    },
    {
        "Code": 688,
        "Waarde": "Nistelrode",
        "Toelichting": "NTR00"
    },
    {
        "Code": 689,
        "Waarde": "Noorbeek",
        "Toelichting": "NBK03"
    },
    {
        "Code": 690,
        "Waarde": "Noordbroek",
        "Toelichting": "NBK01"
    },
    {
        "Code": 691,
        "Waarde": "Noorddijk",
        "Toelichting": "NDK00"
    },
    {
        "Code": 692,
        "Waarde": "Noordeloos",
        "Toelichting": "NDL00"
    },
    {
        "Code": 693,
        "Waarde": "Noorder-Koggenland",
        "Toelichting": "KGL01"
    },
    {
        "Code": 694,
        "Waarde": "Noordoostpolder",
        "Toelichting": "NOP00"
    },
    {
        "Code": 695,
        "Waarde": "Noordwijk",
        "Toelichting": "NWK02"
    },
    {
        "Code": 696,
        "Waarde": "Noordwijkerhout",
        "Toelichting": "NWK04"
    },
    {
        "Code": 697,
        "Waarde": "Noordwolde",
        "Toelichting": "NWD02"
    },
    {
        "Code": 698,
        "Waarde": "Noordzee IV",
        "Toelichting": "NZE04"
    },
    {
        "Code": 699,
        "Waarde": "Noordzee III",
        "Toelichting": "NZE03"
    },
    {
        "Code": 700,
        "Waarde": "Noordzee I",
        "Toelichting": "NZE01"
    },
    {
        "Code": 701,
        "Waarde": "Noordzee II",
        "Toelichting": "NZE02"
    },
    {
        "Code": 702,
        "Waarde": "Noordzee V",
        "Toelichting": "NZE05"
    },
    {
        "Code": 703,
        "Waarde": "Noordzee VI",
        "Toelichting": "NZE06"
    },
    {
        "Code": 704,
        "Waarde": "Noordzee VII",
        "Toelichting": "NZE07"
    },
    {
        "Code": 705,
        "Waarde": "Nootdorp",
        "Toelichting": "NDP01"
    },
    {
        "Code": 706,
        "Waarde": "Norg",
        "Toelichting": "NOR00"
    },
    {
        "Code": 707,
        "Waarde": "Nuenen",
        "Toelichting": "NNN00"
    },
    {
        "Code": 708,
        "Waarde": "Nuland",
        "Toelichting": "NLD03"
    },
    {
        "Code": 709,
        "Waarde": "Numansdorp",
        "Toelichting": "NMD00"
    },
    {
        "Code": 710,
        "Waarde": "Nunhem",
        "Toelichting": "NHM00"
    },
    {
        "Code": 711,
        "Waarde": "Nunspeet",
        "Toelichting": "NST01"
    },
    {
        "Code": 712,
        "Waarde": "Nuth",
        "Toelichting": "NUT00"
    },
    {
        "Code": 713,
        "Waarde": "Obbicht en Papenhoven",
        "Toelichting": "OBT00"
    },
    {
        "Code": 714,
        "Waarde": "Obdam",
        "Toelichting": "ODM01"
    },
    {
        "Code": 715,
        "Waarde": "Ochten",
        "Toelichting": "OTN00"
    },
    {
        "Code": 716,
        "Waarde": "Odijk",
        "Toelichting": "ODK02"
    },
    {
        "Code": 717,
        "Waarde": "Odoorn",
        "Toelichting": "ODN00"
    },
    {
        "Code": 718,
        "Waarde": "Oeffelt",
        "Toelichting": "OFT00"
    },
    {
        "Code": 719,
        "Waarde": "Oegstgeest",
        "Toelichting": "OGT00"
    },
    {
        "Code": 720,
        "Waarde": "Oerle",
        "Toelichting": "OLE00"
    },
    {
        "Code": 721,
        "Waarde": "Ohe en Laak",
        "Toelichting": "OHE00"
    },
    {
        "Code": 722,
        "Waarde": "Oijen",
        "Toelichting": "OEN00"
    },
    {
        "Code": 723,
        "Waarde": "Oirsbeek",
        "Toelichting": "OBK00"
    },
    {
        "Code": 724,
        "Waarde": "Oirschot",
        "Toelichting": "OST00"
    },
    {
        "Code": 725,
        "Waarde": "Oisterwijk",
        "Toelichting": "OTW01"
    },
    {
        "Code": 726,
        "Waarde": "Oldeberkoop",
        "Toelichting": "ODB03"
    },
    {
        "Code": 727,
        "Waarde": "Oldeboorn",
        "Toelichting": "ODB04"
    },
    {
        "Code": 728,
        "Waarde": "Oldebroek",
        "Toelichting": "ODB01"
    },
    {
        "Code": 729,
        "Waarde": "Oldehove",
        "Toelichting": "ODH02"
    },
    {
        "Code": 730,
        "Waarde": "Oldekerk",
        "Toelichting": "ODK01"
    },
    {
        "Code": 731,
        "Waarde": "Oldemarkt",
        "Toelichting": "ODM02"
    },
    {
        "Code": 732,
        "Waarde": "Oldenzaal",
        "Toelichting": "ODZ00"
    },
    {
        "Code": 733,
        "Waarde": "Olst",
        "Toelichting": "OLS00"
    },
    {
        "Code": 734,
        "Waarde": "Ommeren",
        "Toelichting": "OMR02"
    },
    {
        "Code": 735,
        "Waarde": "Onstwedde",
        "Toelichting": "OWD00"
    },
    {
        "Code": 736,
        "Waarde": "Ooij",
        "Toelichting": "OOI00"
    },
    {
        "Code": 737,
        "Waarde": "Ooltgensplaat",
        "Toelichting": "OGP00"
    },
    {
        "Code": 738,
        "Waarde": "Oost-, West- en Middelbeers",
        "Toelichting": "MDB03"
    },
    {
        "Code": 739,
        "Waarde": "Oostburg",
        "Toelichting": "OBG00"
    },
    {
        "Code": 740,
        "Waarde": "Oosterbeek",
        "Toelichting": "OTB00"
    },
    {
        "Code": 741,
        "Waarde": "Oosterend",
        "Toelichting": "OTE00"
    },
    {
        "Code": 742,
        "Waarde": "Oosterhesselen",
        "Toelichting": "OTH02"
    },
    {
        "Code": 743,
        "Waarde": "Oosterhout",
        "Toelichting": "OTH01"
    },
    {
        "Code": 744,
        "Waarde": "Oostermeer",
        "Toelichting": "OTM00"
    },
    {
        "Code": 745,
        "Waarde": "Oosterwierum",
        "Toelichting": "OTW03"
    },
    {
        "Code": 746,
        "Waarde": "Oosterwolde",
        "Toelichting": "OTW02"
    },
    {
        "Code": 747,
        "Waarde": "Oosterzee",
        "Toelichting": "OTZ00"
    },
    {
        "Code": 748,
        "Waarde": "Oostflakkee",
        "Toelichting": "OFK00"
    },
    {
        "Code": 749,
        "Waarde": "Oosthuizen",
        "Toelichting": "OHZ00"
    },
    {
        "Code": 750,
        "Waarde": "Oostvoorne",
        "Toelichting": "OVN00"
    },
    {
        "Code": 751,
        "Waarde": "Oostzaan",
        "Toelichting": "OZN00"
    },
    {
        "Code": 752,
        "Waarde": "Ootmarsum",
        "Toelichting": "OMS00"
    },
    {
        "Code": 753,
        "Waarde": "Ophemert",
        "Toelichting": "OHM00"
    },
    {
        "Code": 754,
        "Waarde": "Opheusden",
        "Toelichting": "OHD00"
    },
    {
        "Code": 755,
        "Waarde": "Oploo",
        "Toelichting": "OLO00"
    },
    {
        "Code": 756,
        "Waarde": "Opmeer",
        "Toelichting": "OMR01"
    },
    {
        "Code": 757,
        "Waarde": "Oppenhuizen",
        "Toelichting": "OPH00"
    },
    {
        "Code": 758,
        "Waarde": "Opperdoes",
        "Toelichting": "OPD00"
    },
    {
        "Code": 759,
        "Waarde": "Oss",
        "Toelichting": "OSS00"
    },
    {
        "Code": 760,
        "Waarde": "Ossendrecht",
        "Toelichting": "OSD00"
    },
    {
        "Code": 761,
        "Waarde": "Otterlo",
        "Toelichting": "OTL02"
    },
    {
        "Code": 762,
        "Waarde": "Ottersum",
        "Toelichting": "OTS00"
    },
    {
        "Code": 763,
        "Waarde": "Ottoland",
        "Toelichting": "OTL01"
    },
    {
        "Code": 764,
        "Waarde": "Oud en Nieuw Gastel",
        "Toelichting": "GTL02"
    },
    {
        "Code": 765,
        "Waarde": "Oud-Alblas",
        "Toelichting": "ABS02"
    },
    {
        "Code": 766,
        "Waarde": "Oud-Beijerland",
        "Toelichting": "BEL01"
    },
    {
        "Code": 767,
        "Waarde": "Ouddorp",
        "Toelichting": "ODP01"
    },
    {
        "Code": 768,
        "Waarde": "Oude Pekela",
        "Toelichting": "PKL02"
    },
    {
        "Code": 769,
        "Waarde": "Oudega",
        "Toelichting": "ODG00"
    },
    {
        "Code": 770,
        "Waarde": "Oudenbosch",
        "Toelichting": "ODB02"
    },
    {
        "Code": 771,
        "Waarde": "Oudenhoorn",
        "Toelichting": "ODH01"
    },
    {
        "Code": 772,
        "Waarde": "Oudenrijn",
        "Toelichting": "ODR02"
    },
    {
        "Code": 773,
        "Waarde": "Ouder-Amstel",
        "Toelichting": "ASL00"
    },
    {
        "Code": 774,
        "Waarde": "Ouderkerk aan den IJssel",
        "Toelichting": "ODK04"
    },
    {
        "Code": 775,
        "Waarde": "Oudetrijne",
        "Toelichting": "ODT00"
    },
    {
        "Code": 776,
        "Waarde": "Oudewater",
        "Toelichting": "ODW00"
    },
    {
        "Code": 777,
        "Waarde": "Oudorp",
        "Toelichting": "ODP02"
    },
    {
        "Code": 778,
        "Waarde": "Oudshoorn",
        "Toelichting": "OHN00"
    },
    {
        "Code": 779,
        "Waarde": "Oud-Valkenburg",
        "Toelichting": "VKB03"
    },
    {
        "Code": 780,
        "Waarde": "Oud-Vossemeer",
        "Toelichting": "VSM03"
    },
    {
        "Code": 781,
        "Waarde": "Oud-Vroenhoven",
        "Toelichting": "VHV03"
    },
    {
        "Code": 782,
        "Waarde": "Oud-Zevenaar",
        "Toelichting": "ZVN02"
    },
    {
        "Code": 783,
        "Waarde": "Overasselt",
        "Toelichting": "OVA00"
    },
    {
        "Code": 784,
        "Waarde": "Overschie",
        "Toelichting": "OVS00"
    },
    {
        "Code": 785,
        "Waarde": "Pannerden",
        "Toelichting": "PND00"
    },
    {
        "Code": 786,
        "Waarde": "Papekop",
        "Toelichting": "PPK00"
    },
    {
        "Code": 787,
        "Waarde": "Papendrecht",
        "Toelichting": "PPD00"
    },
    {
        "Code": 788,
        "Waarde": "Peize",
        "Toelichting": "PZE00"
    },
    {
        "Code": 789,
        "Waarde": "Pernis",
        "Toelichting": "PNS00"
    },
    {
        "Code": 790,
        "Waarde": "Petten",
        "Toelichting": "PTN02"
    },
    {
        "Code": 791,
        "Waarde": "Philippine",
        "Toelichting": "PLP00"
    },
    {
        "Code": 792,
        "Waarde": "Piershil",
        "Toelichting": "PHL00"
    },
    {
        "Code": 793,
        "Waarde": "Pijnacker",
        "Toelichting": "PAK00"
    },
    {
        "Code": 794,
        "Waarde": "Poederoijen",
        "Toelichting": "PDR00"
    },
    {
        "Code": 795,
        "Waarde": "Polsbroek",
        "Toelichting": "PBK00"
    },
    {
        "Code": 796,
        "Waarde": "Poortugaal",
        "Toelichting": "PTG00"
    },
    {
        "Code": 797,
        "Waarde": "Poortvliet",
        "Toelichting": "PVT00"
    },
    {
        "Code": 798,
        "Waarde": "Posterholt",
        "Toelichting": "PTH02"
    },
    {
        "Code": 799,
        "Waarde": "Princenhage",
        "Toelichting": "PCH00"
    },
    {
        "Code": 800,
        "Waarde": "Prinsenbeek",
        "Toelichting": "PSB00"
    },
    {
        "Code": 801,
        "Waarde": "Purmerend",
        "Toelichting": "PMR00"
    },
    {
        "Code": 802,
        "Waarde": "Putte",
        "Toelichting": "PTE00"
    },
    {
        "Code": 803,
        "Waarde": "Putten",
        "Toelichting": "PTN01"
    },
    {
        "Code": 804,
        "Waarde": "Puttershoek",
        "Toelichting": "PTH01"
    },
    {
        "Code": 805,
        "Waarde": "Raalte",
        "Toelichting": "RTE00"
    },
    {
        "Code": 806,
        "Waarde": "Raamsdonk",
        "Toelichting": "RDK02"
    },
    {
        "Code": 807,
        "Waarde": "Randwijk",
        "Toelichting": "RWK03"
    },
    {
        "Code": 808,
        "Waarde": "Ransdorp",
        "Toelichting": "RDP00"
    },
    {
        "Code": 809,
        "Waarde": "Rauwerd",
        "Toelichting": "RWD02"
    },
    {
        "Code": 810,
        "Waarde": "Ravenstein",
        "Toelichting": "RVS00"
    },
    {
        "Code": 811,
        "Waarde": "Reeuwijk",
        "Toelichting": "RWK02"
    },
    {
        "Code": 812,
        "Waarde": "Reimerswaal",
        "Toelichting": "RMW00"
    },
    {
        "Code": 813,
        "Waarde": "Renkum",
        "Toelichting": "RKM00"
    },
    {
        "Code": 814,
        "Waarde": "Renswoude",
        "Toelichting": "RWD01"
    },
    {
        "Code": 815,
        "Waarde": "Ressen",
        "Toelichting": "RSN02"
    },
    {
        "Code": 816,
        "Waarde": "Reusel",
        "Toelichting": "RSL00"
    },
    {
        "Code": 817,
        "Waarde": "Rheden",
        "Toelichting": "RDN02"
    },
    {
        "Code": 818,
        "Waarde": "Rhenen",
        "Toelichting": "RNN01"
    },
    {
        "Code": 819,
        "Waarde": "Rhoon",
        "Toelichting": "RHO00"
    },
    {
        "Code": 820,
        "Waarde": "Ridderkerk",
        "Toelichting": "RDK01"
    },
    {
        "Code": 821,
        "Waarde": "Ried",
        "Toelichting": "RIE00"
    },
    {
        "Code": 822,
        "Waarde": "Riethoven",
        "Toelichting": "RHV00"
    },
    {
        "Code": 823,
        "Waarde": "Rietveld",
        "Toelichting": "RVD00"
    },
    {
        "Code": 824,
        "Waarde": "Rijckholt",
        "Toelichting": "RHT00"
    },
    {
        "Code": 825,
        "Waarde": "Rijnsaterwoude",
        "Toelichting": "RST00"
    },
    {
        "Code": 826,
        "Waarde": "Rijnsburg",
        "Toelichting": "RBG02"
    },
    {
        "Code": 827,
        "Waarde": "Rijsbergen",
        "Toelichting": "RBG01"
    },
    {
        "Code": 828,
        "Waarde": "Rijssen",
        "Toelichting": "RSN01"
    },
    {
        "Code": 829,
        "Waarde": "Rijswijk",
        "Toelichting": "RWK01"
    },
    {
        "Code": 830,
        "Waarde": "Rilland",
        "Toelichting": "RLD00"
    },
    {
        "Code": 831,
        "Waarde": "Rockanje",
        "Toelichting": "RKJ00"
    },
    {
        "Code": 832,
        "Waarde": "Roden",
        "Toelichting": "RDN01"
    },
    {
        "Code": 833,
        "Waarde": "Roermond",
        "Toelichting": "RMD00"
    },
    {
        "Code": 834,
        "Waarde": "Roggel",
        "Toelichting": "RGL00"
    },
    {
        "Code": 835,
        "Waarde": "Rolde",
        "Toelichting": "RDE00"
    },
    {
        "Code": 836,
        "Waarde": "Roordahuizum",
        "Toelichting": "RDH00"
    },
    {
        "Code": 837,
        "Waarde": "Roosendaal en Nispen",
        "Toelichting": "RSD00"
    },
    {
        "Code": 838,
        "Waarde": "Roosteren",
        "Toelichting": "RTR00"
    },
    {
        "Code": 839,
        "Waarde": "Rosmalen",
        "Toelichting": "RML00"
    },
    {
        "Code": 840,
        "Waarde": "Rossum",
        "Toelichting": "RSM00"
    },
    {
        "Code": 841,
        "Waarde": "Rotterdam",
        "Toelichting": "RTD06;RTD07;RTD09;RTD10;RTD13;RTD04;RTD05;RTD08;RTD12;RTD14"
    },
    {
        "Code": 842,
        "Waarde": "Rottevalle",
        "Toelichting": "RTV00"
    },
    {
        "Code": 843,
        "Waarde": "Rozenburg",
        "Toelichting": "RZB00"
    },
    {
        "Code": 844,
        "Waarde": "Rozendaal",
        "Toelichting": "RZD00"
    },
    {
        "Code": 845,
        "Waarde": "Rucphen",
        "Toelichting": "RPN00"
    },
    {
        "Code": 846,
        "Waarde": "Ruinen",
        "Toelichting": "RNN02"
    },
    {
        "Code": 847,
        "Waarde": "Ruinerwold",
        "Toelichting": "RNW00"
    },
    {
        "Code": 848,
        "Waarde": "Ruurlo",
        "Toelichting": "RLO00"
    },
    {
        "Code": 849,
        "Waarde": "Ruwiel",
        "Toelichting": "RWL00"
    },
    {
        "Code": 850,
        "Waarde": "Sappemeer",
        "Toelichting": "SPM00"
    },
    {
        "Code": 851,
        "Waarde": "Sas van Gent",
        "Toelichting": "SAS00"
    },
    {
        "Code": 852,
        "Waarde": "Sassenheim",
        "Toelichting": "SSH00"
    },
    {
        "Code": 853,
        "Waarde": "Schaesberg",
        "Toelichting": "SBG01"
    },
    {
        "Code": 854,
        "Waarde": "Schagen",
        "Toelichting": "SGN00"
    },
    {
        "Code": 855,
        "Waarde": "Schaijk",
        "Toelichting": "SCH03"
    },
    {
        "Code": 856,
        "Waarde": "Schalkwijk",
        "Toelichting": "SWK04"
    },
    {
        "Code": 857,
        "Waarde": "Scharnegoutum",
        "Toelichting": "SNG00"
    },
    {
        "Code": 858,
        "Waarde": "Scheemda",
        "Toelichting": "SDA00"
    },
    {
        "Code": 859,
        "Waarde": "Schelluinen",
        "Toelichting": "SLN00"
    },
    {
        "Code": 860,
        "Waarde": "Schermer",
        "Toelichting": "SMR01"
    },
    {
        "Code": 861,
        "Waarde": "Scherpenisse",
        "Toelichting": "SPN00"
    },
    {
        "Code": 862,
        "Waarde": "Scherpenzeel",
        "Toelichting": "SPZ00"
    },
    {
        "Code": 863,
        "Waarde": "Schiebroek",
        "Toelichting": "SBK01"
    },
    {
        "Code": 864,
        "Waarde": "Schiedam",
        "Toelichting": "SDM01"
    },
    {
        "Code": 865,
        "Waarde": "Schiermonnikoog",
        "Toelichting": "SMN01"
    },
    {
        "Code": 866,
        "Waarde": "Schijndel",
        "Toelichting": "SDL00"
    },
    {
        "Code": 867,
        "Waarde": "Schimmert",
        "Toelichting": "SMT00"
    },
    {
        "Code": 868,
        "Waarde": "Schin op Geul",
        "Toelichting": "SCH02"
    },
    {
        "Code": 869,
        "Waarde": "Schinnen",
        "Toelichting": "SNN00"
    },
    {
        "Code": 870,
        "Waarde": "Schinveld",
        "Toelichting": "SVD00"
    },
    {
        "Code": 871,
        "Waarde": "Schipluiden",
        "Toelichting": "SLD02"
    },
    {
        "Code": 872,
        "Waarde": "Schoonebeek",
        "Toelichting": "SNB00"
    },
    {
        "Code": 873,
        "Waarde": "Schoonhoven",
        "Toelichting": "SHV00"
    },
    {
        "Code": 874,
        "Waarde": "Schoonrewoerd",
        "Toelichting": "SRW02"
    },
    {
        "Code": 875,
        "Waarde": "Schoorl",
        "Toelichting": "SCH01"
    },
    {
        "Code": 876,
        "Waarde": "Schoten",
        "Toelichting": "STN01"
    },
    {
        "Code": 877,
        "Waarde": "Sevenum",
        "Toelichting": "SVN01"
    },
    {
        "Code": 878,
        "Waarde": "Sexbierum",
        "Toelichting": "SBR00"
    },
    {
        "Code": 879,
        "Waarde": "'s-Graveland",
        "Toelichting": "GVL00"
    },
    {
        "Code": 880,
        "Waarde": "'s-Gravendeel",
        "Toelichting": "GVD02"
    },
    {
        "Code": 881,
        "Waarde": "'s-Gravenhage",
        "Toelichting": "GVH00;GVH01;GVH02;GVH03;GVH04;GVH05;GVH06;GVH07;GVH08;GVH09;GVH10;GVH11;GVH12;GVH13;GVH14;GVH15;GVH16;GVH17;GVH18;GVH19;GVH20;GVH21;GVH22;GVH23;GVH24;GVH25;GVH26;GVH27;GVH28;GVH29;GVH30;GVH31;GVH32;GVH33;GVH34;GVH35;GVH36;GVH37;GVH38;GVH39;GVH40;GVH41;GVH42;GVH43;GVH44;GVH45;GVH46;GVH47;GVH48;GVH49"
    },
    {
        "Code": 882,
        "Waarde": "'s-Gravenmoer",
        "Toelichting": "GVM00"
    },
    {
        "Code": 883,
        "Waarde": "'s-Gravenzande",
        "Toelichting": "GVZ00"
    },
    {
        "Code": 884,
        "Waarde": "'s-Heer Hendrikskinderen",
        "Toelichting": "HDK01"
    },
    {
        "Code": 885,
        "Waarde": "'s-Heerenberg",
        "Toelichting": "HRB00"
    },
    {
        "Code": 886,
        "Waarde": "'s-Hertogenbosch",
        "Toelichting": "HTG00"
    },
    {
        "Code": 887,
        "Waarde": "Sijbekarspel",
        "Toelichting": "SBK02"
    },
    {
        "Code": 888,
        "Waarde": "Simpelveld",
        "Toelichting": "SPV00"
    },
    {
        "Code": 889,
        "Waarde": "Sint Anna Parochie",
        "Toelichting": "ANA02"
    },
    {
        "Code": 890,
        "Waarde": "Sint Annaland",
        "Toelichting": "ANL00"
    },
    {
        "Code": 891,
        "Waarde": "Sint Geertruid",
        "Toelichting": "GTD02"
    },
    {
        "Code": 892,
        "Waarde": "Sint Jacobi Parochie",
        "Toelichting": "JCB00"
    },
    {
        "Code": 893,
        "Waarde": "Sint Jansteen",
        "Toelichting": "JSN00"
    },
    {
        "Code": 894,
        "Waarde": "Sint Johannesga",
        "Toelichting": "JHN00"
    },
    {
        "Code": 895,
        "Waarde": "Sint Kruis",
        "Toelichting": "KRU00"
    },
    {
        "Code": 896,
        "Waarde": "Sint Maarten",
        "Toelichting": "MTN00"
    },
    {
        "Code": 897,
        "Waarde": "Sint Maartensdijk",
        "Toelichting": "MTD03"
    },
    {
        "Code": 898,
        "Waarde": "Sint Michielsgestel",
        "Toelichting": "MCG00"
    },
    {
        "Code": 899,
        "Waarde": "Sint Odilienberg",
        "Toelichting": "ODL00"
    },
    {
        "Code": 900,
        "Waarde": "Sint Oedenrode",
        "Toelichting": "ODR01"
    },
    {
        "Code": 901,
        "Waarde": "Sint Pancras",
        "Toelichting": "PCS00"
    },
    {
        "Code": 902,
        "Waarde": "Sint Philipsland",
        "Toelichting": "PLL00"
    },
    {
        "Code": 903,
        "Waarde": "Sint Pieter",
        "Toelichting": "PTR00"
    },
    {
        "Code": 904,
        "Waarde": "Sittard",
        "Toelichting": "STD00"
    },
    {
        "Code": 905,
        "Waarde": "Sleen",
        "Toelichting": "SLE00"
    },
    {
        "Code": 906,
        "Waarde": "Slenaken",
        "Toelichting": "SAK00"
    },
    {
        "Code": 907,
        "Waarde": "Sliedrecht",
        "Toelichting": "SDT00"
    },
    {
        "Code": 908,
        "Waarde": "Slijk-Ewijk",
        "Toelichting": "SLI00"
    },
    {
        "Code": 909,
        "Waarde": "Slochteren",
        "Toelichting": "STR02"
    },
    {
        "Code": 910,
        "Waarde": "Sloten Friesland",
        "Toelichting": "STN03"
    },
    {
        "Code": 911,
        "Waarde": "Sloten Noord-Holland",
        "Toelichting": "STN02"
    },
    {
        "Code": 912,
        "Waarde": "Sluis",
        "Toelichting": "SLU00"
    },
    {
        "Code": 913,
        "Waarde": "Smilde",
        "Toelichting": "SDE01"
    },
    {
        "Code": 914,
        "Waarde": "Sneek",
        "Toelichting": "SNE00"
    },
    {
        "Code": 915,
        "Waarde": "Snelrewaard",
        "Toelichting": "SRW01"
    },
    {
        "Code": 916,
        "Waarde": "Soerendonk",
        "Toelichting": "SRD00"
    },
    {
        "Code": 917,
        "Waarde": "Soest",
        "Toelichting": "SOE00"
    },
    {
        "Code": 918,
        "Waarde": "Someren",
        "Toelichting": "SMR02"
    },
    {
        "Code": 919,
        "Waarde": "Sommelsdijk",
        "Toelichting": "SMD00"
    },
    {
        "Code": 920,
        "Waarde": "Son en Breugel",
        "Toelichting": "SON00"
    },
    {
        "Code": 921,
        "Waarde": "Spaubeek",
        "Toelichting": "SBK03"
    },
    {
        "Code": 922,
        "Waarde": "Spijkenisse",
        "Toelichting": "SKN00"
    },
    {
        "Code": 923,
        "Waarde": "Sprang",
        "Toelichting": "SPR01"
    },
    {
        "Code": 924,
        "Waarde": "Stad aan het Haringvliet",
        "Toelichting": "HRV02"
    },
    {
        "Code": 925,
        "Waarde": "Stad-Almelo",
        "Toelichting": "AML02"
    },
    {
        "Code": 926,
        "Waarde": "Stad-Delden",
        "Toelichting": "DDN02"
    },
    {
        "Code": 927,
        "Waarde": "Stad-Doetinchem",
        "Toelichting": "DTC02"
    },
    {
        "Code": 928,
        "Waarde": "Stad-Hardenberg",
        "Toelichting": "HDB02"
    },
    {
        "Code": 929,
        "Waarde": "Stad-Ommen",
        "Toelichting": "OMN02"
    },
    {
        "Code": 930,
        "Waarde": "Standdaarbuiten",
        "Toelichting": "SDB02"
    },
    {
        "Code": 931,
        "Waarde": "Staphorst",
        "Toelichting": "SHT02"
    },
    {
        "Code": 932,
        "Waarde": "Stavenisse",
        "Toelichting": "SVN02"
    },
    {
        "Code": 933,
        "Waarde": "Staveren",
        "Toelichting": "SVR00"
    },
    {
        "Code": 934,
        "Waarde": "Stede Broec",
        "Toelichting": "SDE02"
    },
    {
        "Code": 935,
        "Waarde": "Stedum",
        "Toelichting": "SDM02"
    },
    {
        "Code": 936,
        "Waarde": "Steenbergen",
        "Toelichting": "SBG02"
    },
    {
        "Code": 937,
        "Waarde": "Steenderen",
        "Toelichting": "SDR00"
    },
    {
        "Code": 938,
        "Waarde": "Steenwijk",
        "Toelichting": "SWK01"
    },
    {
        "Code": 939,
        "Waarde": "Steenwijkerwold",
        "Toelichting": "SWK05"
    },
    {
        "Code": 940,
        "Waarde": "Stein",
        "Toelichting": "STE00"
    },
    {
        "Code": 941,
        "Waarde": "Stellendam",
        "Toelichting": "SLD01"
    },
    {
        "Code": 942,
        "Waarde": "Stevensweert",
        "Toelichting": "SVW00"
    },
    {
        "Code": 943,
        "Waarde": "Stiphout",
        "Toelichting": "SHT01"
    },
    {
        "Code": 944,
        "Waarde": "Stolwijk",
        "Toelichting": "SWK02"
    },
    {
        "Code": 945,
        "Waarde": "Stompwijk",
        "Toelichting": "SWK03"
    },
    {
        "Code": 946,
        "Waarde": "Stoutenburg",
        "Toelichting": "STB00"
    },
    {
        "Code": 947,
        "Waarde": "Stramproy",
        "Toelichting": "SRY00"
    },
    {
        "Code": 948,
        "Waarde": "Stratum",
        "Toelichting": "STM00"
    },
    {
        "Code": 949,
        "Waarde": "Streefkerk",
        "Toelichting": "SKK00"
    },
    {
        "Code": 950,
        "Waarde": "Strijen",
        "Toelichting": "SEN00"
    },
    {
        "Code": 951,
        "Waarde": "Strijp",
        "Toelichting": "STR03"
    },
    {
        "Code": 952,
        "Waarde": "Surhuizum",
        "Toelichting": "SHZ00"
    },
    {
        "Code": 953,
        "Waarde": "Susteren",
        "Toelichting": "STR01"
    },
    {
        "Code": 954,
        "Waarde": "Swalmen",
        "Toelichting": "SMN02"
    },
    {
        "Code": 955,
        "Waarde": "'t Zandt",
        "Toelichting": "ZAN00"
    },
    {
        "Code": 956,
        "Waarde": "Tegelen",
        "Toelichting": "TGL00"
    },
    {
        "Code": 957,
        "Waarde": "ten Boer",
        "Toelichting": "BOE00"
    },
    {
        "Code": 958,
        "Waarde": "Ter Aar",
        "Toelichting": "AAR00"
    },
    {
        "Code": 959,
        "Waarde": "Terheijden",
        "Toelichting": "THD00"
    },
    {
        "Code": 960,
        "Waarde": "Terhorne",
        "Toelichting": "THN00"
    },
    {
        "Code": 961,
        "Waarde": "Termunten",
        "Toelichting": "TMT00"
    },
    {
        "Code": 962,
        "Waarde": "Ternaard",
        "Toelichting": "TND00"
    },
    {
        "Code": 963,
        "Waarde": "Terneuzen",
        "Toelichting": "TNZ00"
    },
    {
        "Code": 964,
        "Waarde": "Terschelling",
        "Toelichting": "TSL00"
    },
    {
        "Code": 965,
        "Waarde": "Teteringen",
        "Toelichting": "TTR00"
    },
    {
        "Code": 966,
        "Waarde": "Texel",
        "Toelichting": "TEL00"
    },
    {
        "Code": 967,
        "Waarde": "Tholen",
        "Toelichting": "TLN00"
    },
    {
        "Code": 968,
        "Waarde": "Thorn",
        "Toelichting": "THO00"
    },
    {
        "Code": 969,
        "Waarde": "Tiel",
        "Toelichting": "TIE00"
    },
    {
        "Code": 970,
        "Waarde": "Tienhoven",
        "Toelichting": "THV00"
    },
    {
        "Code": 971,
        "Waarde": "Tilburg",
        "Toelichting": "TBG01"
    },
    {
        "Code": 972,
        "Waarde": "Tjalleberd",
        "Toelichting": "TLB00"
    },
    {
        "Code": 973,
        "Waarde": "Tjerkwerd",
        "Toelichting": "TWD00"
    },
    {
        "Code": 974,
        "Waarde": "Tjum",
        "Toelichting": "TJU00"
    },
    {
        "Code": 975,
        "Waarde": "Tolsteeg",
        "Toelichting": "TSG00"
    },
    {
        "Code": 976,
        "Waarde": "Tongelre",
        "Toelichting": "TGR00"
    },
    {
        "Code": 977,
        "Waarde": "Tubbergen",
        "Toelichting": "TBG02"
    },
    {
        "Code": 978,
        "Waarde": "Tull en 't Waal",
        "Toelichting": "TUL00"
    },
    {
        "Code": 979,
        "Waarde": "Twello",
        "Toelichting": "TLO00"
    },
    {
        "Code": 980,
        "Waarde": "Twisk",
        "Toelichting": "TWI00"
    },
    {
        "Code": 981,
        "Waarde": "Tzummarum",
        "Toelichting": "TMU00"
    },
    {
        "Code": 982,
        "Waarde": "Ubach over Worms",
        "Toelichting": "UBH00"
    },
    {
        "Code": 983,
        "Waarde": "Ubbergen",
        "Toelichting": "UBG00"
    },
    {
        "Code": 984,
        "Waarde": "Uden",
        "Toelichting": "UDN00"
    },
    {
        "Code": 985,
        "Waarde": "Udenhout",
        "Toelichting": "UDH00"
    },
    {
        "Code": 986,
        "Waarde": "Uitgeest",
        "Toelichting": "UGT00"
    },
    {
        "Code": 987,
        "Waarde": "Uithoorn",
        "Toelichting": "UHN00"
    },
    {
        "Code": 988,
        "Waarde": "Uithuizen",
        "Toelichting": "UHZ01"
    },
    {
        "Code": 989,
        "Waarde": "Uithuizermeeden",
        "Toelichting": "UHZ02"
    },
    {
        "Code": 990,
        "Waarde": "Ulestraten",
        "Toelichting": "ULS00"
    },
    {
        "Code": 991,
        "Waarde": "Ulrum",
        "Toelichting": "URM00"
    },
    {
        "Code": 992,
        "Waarde": "Ureterp",
        "Toelichting": "URT00"
    },
    {
        "Code": 993,
        "Waarde": "Urk",
        "Toelichting": "URK00"
    },
    {
        "Code": 994,
        "Waarde": "Urmond",
        "Toelichting": "UMD00"
    },
    {
        "Code": 995,
        "Waarde": "Usquert",
        "Toelichting": "UQT00"
    },
    {
        "Code": 996,
        "Waarde": "Utrecht",
        "Toelichting": "UTT00"
    },
    {
        "Code": 997,
        "Waarde": "Vaals",
        "Toelichting": "VAA00"
    },
    {
        "Code": 998,
        "Waarde": "Vaassen",
        "Toelichting": "VSN02"
    },
    {
        "Code": 999,
        "Waarde": "Valburg",
        "Toelichting": "VBG02"
    },
    {
        "Code": 1000,
        "Waarde": "Valkenburg Limburg",
        "Toelichting": "VKB01"
    },
    {
        "Code": 1001,
        "Waarde": "Valkenburg Zuid-Holland",
        "Toelichting": "VKB02"
    },
    {
        "Code": 1002,
        "Waarde": "Valkenisse",
        "Toelichting": "VKN00"
    },
    {
        "Code": 1003,
        "Waarde": "Valkenswaard",
        "Toelichting": "VKW00"
    },
    {
        "Code": 1004,
        "Waarde": "Varik",
        "Toelichting": "VRK00"
    },
    {
        "Code": 1005,
        "Waarde": "Varsseveld",
        "Toelichting": "VSV00"
    },
    {
        "Code": 1006,
        "Waarde": "Veendam",
        "Toelichting": "VDM00"
    },
    {
        "Code": 1007,
        "Waarde": "Veenendaal",
        "Toelichting": "VND00"
    },
    {
        "Code": 1008,
        "Waarde": "Veenwouden",
        "Toelichting": "VWD01"
    },
    {
        "Code": 1009,
        "Waarde": "Veere",
        "Toelichting": "VRE00"
    },
    {
        "Code": 1010,
        "Waarde": "Veessen",
        "Toelichting": "VSN03"
    },
    {
        "Code": 1011,
        "Waarde": "Veghel",
        "Toelichting": "VHL00"
    },
    {
        "Code": 1012,
        "Waarde": "Veldhoven",
        "Toelichting": "VHV01"
    },
    {
        "Code": 1013,
        "Waarde": "Veldhuizen",
        "Toelichting": "VHZ01"
    },
    {
        "Code": 1014,
        "Waarde": "Velp Gelderland",
        "Toelichting": "VEL01"
    },
    {
        "Code": 1015,
        "Waarde": "Velp Noord-Brabant",
        "Toelichting": "VEL02"
    },
    {
        "Code": 1016,
        "Waarde": "Velsen",
        "Toelichting": "VSN01"
    },
    {
        "Code": 1017,
        "Waarde": "Venhuizen",
        "Toelichting": "VHZ03"
    },
    {
        "Code": 1018,
        "Waarde": "Venlo",
        "Toelichting": "VLO00"
    },
    {
        "Code": 1019,
        "Waarde": "Venray",
        "Toelichting": "VRY00"
    },
    {
        "Code": 1020,
        "Waarde": "Vessem",
        "Toelichting": "VSM01"
    },
    {
        "Code": 1021,
        "Waarde": "Veur",
        "Toelichting": "VEU00"
    },
    {
        "Code": 1022,
        "Waarde": "Vianen",
        "Toelichting": "VAN00"
    },
    {
        "Code": 1023,
        "Waarde": "Vierlingsbeek",
        "Toelichting": "VLB00"
    },
    {
        "Code": 1024,
        "Waarde": "Vierpolders",
        "Toelichting": "VPD00"
    },
    {
        "Code": 1025,
        "Waarde": "Vinkeveen",
        "Toelichting": "VKV00"
    },
    {
        "Code": 1026,
        "Waarde": "Vlaardingen",
        "Toelichting": "VDG00"
    },
    {
        "Code": 1027,
        "Waarde": "Vlagtwedde",
        "Toelichting": "VWD02"
    },
    {
        "Code": 1028,
        "Waarde": "Vledder",
        "Toelichting": "VDR00"
    },
    {
        "Code": 1029,
        "Waarde": "Vleuten",
        "Toelichting": "VTN00"
    },
    {
        "Code": 1030,
        "Waarde": "Vlieland",
        "Toelichting": "VLD01"
    },
    {
        "Code": 1031,
        "Waarde": "Vlierden",
        "Toelichting": "VDN01"
    },
    {
        "Code": 1032,
        "Waarde": "Vlijmen",
        "Toelichting": "VMN00"
    },
    {
        "Code": 1033,
        "Waarde": "Vlissingen",
        "Toelichting": "VSG00"
    },
    {
        "Code": 1034,
        "Waarde": "Vlist",
        "Toelichting": "VLI00"
    },
    {
        "Code": 1035,
        "Waarde": "Vlodrop",
        "Toelichting": "VDP00"
    },
    {
        "Code": 1036,
        "Waarde": "Voerendaal",
        "Toelichting": "VRD00"
    },
    {
        "Code": 1037,
        "Waarde": "Vollenhove",
        "Toelichting": "VLH00"
    },
    {
        "Code": 1038,
        "Waarde": "Voorburg",
        "Toelichting": "VBG01"
    },
    {
        "Code": 1039,
        "Waarde": "Voorhout",
        "Toelichting": "VHT00"
    },
    {
        "Code": 1040,
        "Waarde": "Voorschoten",
        "Toelichting": "VST00"
    },
    {
        "Code": 1041,
        "Waarde": "Voorst",
        "Toelichting": "VOO00"
    },
    {
        "Code": 1042,
        "Waarde": "Voorthuizen",
        "Toelichting": "VHZ02"
    },
    {
        "Code": 1043,
        "Waarde": "Vorden",
        "Toelichting": "VDN02"
    },
    {
        "Code": 1044,
        "Waarde": "Vreeland",
        "Toelichting": "VLD02"
    },
    {
        "Code": 1045,
        "Waarde": "Vreeswijk",
        "Toelichting": "VWK00"
    },
    {
        "Code": 1046,
        "Waarde": "Vries",
        "Toelichting": "VRI00"
    },
    {
        "Code": 1047,
        "Waarde": "Vriezenveen",
        "Toelichting": "VZV00"
    },
    {
        "Code": 1048,
        "Waarde": "Vrijhoeve-Capelle",
        "Toelichting": "VHV02"
    },
    {
        "Code": 1049,
        "Waarde": "Vught",
        "Toelichting": "VUG00"
    },
    {
        "Code": 1050,
        "Waarde": "Vuren",
        "Toelichting": "VRN00"
    },
    {
        "Code": 1051,
        "Waarde": "Waalre",
        "Toelichting": "WRE02"
    },
    {
        "Code": 1052,
        "Waarde": "Waalwijk",
        "Toelichting": "WWK00"
    },
    {
        "Code": 1053,
        "Waarde": "Waarde",
        "Toelichting": "WDE01"
    },
    {
        "Code": 1054,
        "Waarde": "Waarder",
        "Toelichting": "(was dubbel met 1056)"
    },
    {
        "Code": 1055,
        "Waarde": "Waardenburg",
        "Toelichting": "WDB01"
    },
    {
        "Code": 1056,
        "Waarde": "Waarder",
        "Toelichting": "WDR02"
    },
    {
        "Code": 1057,
        "Waarde": "Waddenzee III",
        "Toelichting": "WDZ03"
    },
    {
        "Code": 1058,
        "Waarde": "Waddenzee I",
        "Toelichting": "WDZ01"
    },
    {
        "Code": 1059,
        "Waarde": "Waddenzee II",
        "Toelichting": "WDZ02"
    },
    {
        "Code": 1060,
        "Waarde": "Waddinxveen",
        "Toelichting": "WDV01"
    },
    {
        "Code": 1061,
        "Waarde": "Wadenoijen",
        "Toelichting": "WDN03"
    },
    {
        "Code": 1062,
        "Waarde": "Wageningen",
        "Toelichting": "WGN00"
    },
    {
        "Code": 1063,
        "Waarde": "Wamel",
        "Toelichting": "WML00"
    },
    {
        "Code": 1064,
        "Waarde": "Wanneperveen",
        "Toelichting": "WNP00"
    },
    {
        "Code": 1065,
        "Waarde": "Wanroij",
        "Toelichting": "WRJ00"
    },
    {
        "Code": 1066,
        "Waarde": "Wanssum",
        "Toelichting": "WSM02"
    },
    {
        "Code": 1067,
        "Waarde": "Warder",
        "Toelichting": "WDR01"
    },
    {
        "Code": 1068,
        "Waarde": "Warffum",
        "Toelichting": "WFM00"
    },
    {
        "Code": 1069,
        "Waarde": "Warmenhuizen",
        "Toelichting": "WMH00"
    },
    {
        "Code": 1070,
        "Waarde": "Warmond",
        "Toelichting": "WMD01"
    },
    {
        "Code": 1071,
        "Waarde": "Warnsveld",
        "Toelichting": "WVD00"
    },
    {
        "Code": 1072,
        "Waarde": "Warrega",
        "Toelichting": "WRG04"
    },
    {
        "Code": 1073,
        "Waarde": "Waspik",
        "Toelichting": "WPK01"
    },
    {
        "Code": 1074,
        "Waarde": "Wassenaar",
        "Toelichting": "WSN01"
    },
    {
        "Code": 1075,
        "Waarde": "Watergraafsmeer",
        "Toelichting": "WTG02"
    },
    {
        "Code": 1076,
        "Waarde": "Wateringen",
        "Toelichting": "WTR00"
    },
    {
        "Code": 1077,
        "Waarde": "Waterland",
        "Toelichting": "WTL00"
    },
    {
        "Code": 1078,
        "Waarde": "Waverveen",
        "Toelichting": "WVV00"
    },
    {
        "Code": 1079,
        "Waarde": "Wedde",
        "Toelichting": "WDE03"
    },
    {
        "Code": 1080,
        "Waarde": "Weerselo",
        "Toelichting": "WSL02"
    },
    {
        "Code": 1081,
        "Waarde": "Weert",
        "Toelichting": "WEE01"
    },
    {
        "Code": 1082,
        "Waarde": "Weesp",
        "Toelichting": "WEE02"
    },
    {
        "Code": 1083,
        "Waarde": "Weesperkarspel",
        "Toelichting": "WPK02"
    },
    {
        "Code": 1084,
        "Waarde": "Wehl",
        "Toelichting": "WEH00"
    },
    {
        "Code": 1085,
        "Waarde": "Wemeldinge",
        "Toelichting": "WMD02"
    },
    {
        "Code": 1086,
        "Waarde": "Werkendam",
        "Toelichting": "WKD00"
    },
    {
        "Code": 1087,
        "Waarde": "Werkhoven",
        "Toelichting": "WHV00"
    },
    {
        "Code": 1088,
        "Waarde": "Wervershoof",
        "Toelichting": "WVH00"
    },
    {
        "Code": 1089,
        "Waarde": "Wessem",
        "Toelichting": "WSM01"
    },
    {
        "Code": 1090,
        "Waarde": "Westbroek",
        "Toelichting": "WBK00"
    },
    {
        "Code": 1091,
        "Waarde": "Westdorpe",
        "Toelichting": "WDP00"
    },
    {
        "Code": 1092,
        "Waarde": "Westerbork",
        "Toelichting": "WTB00"
    },
    {
        "Code": 1093,
        "Waarde": "Westergeest",
        "Toelichting": "WTG01"
    },
    {
        "Code": 1094,
        "Waarde": "Westerhoven",
        "Toelichting": "WTH00"
    },
    {
        "Code": 1095,
        "Waarde": "Wester-Koggenland",
        "Toelichting": "KGL02"
    },
    {
        "Code": 1096,
        "Waarde": "Westerschouwen",
        "Toelichting": "WTS00"
    },
    {
        "Code": 1097,
        "Waarde": "Westervoort",
        "Toelichting": "WTV00"
    },
    {
        "Code": 1098,
        "Waarde": "Westkapelle",
        "Toelichting": "WKP00"
    },
    {
        "Code": 1099,
        "Waarde": "Westmaas",
        "Toelichting": "WMS01"
    },
    {
        "Code": 1100,
        "Waarde": "Westvoorne",
        "Toelichting": "WVN00"
    },
    {
        "Code": 1101,
        "Waarde": "Westzaan",
        "Toelichting": "WZN00"
    },
    {
        "Code": 1102,
        "Waarde": "Weurt",
        "Toelichting": "WEU00"
    },
    {
        "Code": 1103,
        "Waarde": "Wierden",
        "Toelichting": "WDN02"
    },
    {
        "Code": 1104,
        "Waarde": "Wieringen",
        "Toelichting": "WRG01"
    },
    {
        "Code": 1105,
        "Waarde": "Wieringermeer",
        "Toelichting": "WRG03"
    },
    {
        "Code": 1106,
        "Waarde": "Wieringerwaard",
        "Toelichting": "WRG02"
    },
    {
        "Code": 1107,
        "Waarde": "Wijchen",
        "Toelichting": "WCN00"
    },
    {
        "Code": 1108,
        "Waarde": "Wijdewormer",
        "Toelichting": "WDW00"
    },
    {
        "Code": 1109,
        "Waarde": "Wijhe",
        "Toelichting": "WHE00"
    },
    {
        "Code": 1110,
        "Waarde": "Wijk aan Zee en Duin",
        "Toelichting": "WIJ02"
    },
    {
        "Code": 1111,
        "Waarde": "Wijk bij Duurstede",
        "Toelichting": "WIJ01"
    },
    {
        "Code": 1112,
        "Waarde": "Wijlre",
        "Toelichting": "WRE01"
    },
    {
        "Code": 1113,
        "Waarde": "Wijnandsrade",
        "Toelichting": "WNR00"
    },
    {
        "Code": 1114,
        "Waarde": "Wijngaarden",
        "Toelichting": "WGD00"
    },
    {
        "Code": 1115,
        "Waarde": "Wildervank",
        "Toelichting": "WDV02;WDV03"
    },
    {
        "Code": 1116,
        "Waarde": "Willemstad",
        "Toelichting": "WLS00"
    },
    {
        "Code": 1117,
        "Waarde": "Willeskop",
        "Toelichting": "WLK00"
    },
    {
        "Code": 1118,
        "Waarde": "Willige-Langerak",
        "Toelichting": "WLG00"
    },
    {
        "Code": 1119,
        "Waarde": "Wilnis",
        "Toelichting": "WNS00"
    },
    {
        "Code": 1120,
        "Waarde": "Wilp",
        "Toelichting": "WIL00"
    },
    {
        "Code": 1121,
        "Waarde": "Wilsum",
        "Toelichting": "WSM03"
    },
    {
        "Code": 1122,
        "Waarde": "Winschoten",
        "Toelichting": "WST00"
    },
    {
        "Code": 1123,
        "Waarde": "Winssen",
        "Toelichting": "WSN02"
    },
    {
        "Code": 1124,
        "Waarde": "Winsum",
        "Toelichting": "WSM04"
    },
    {
        "Code": 1125,
        "Waarde": "Winterswijk",
        "Toelichting": "WTW00"
    },
    {
        "Code": 1126,
        "Waarde": "Wirdum",
        "Toelichting": "WDM00"
    },
    {
        "Code": 1127,
        "Waarde": "Wisch",
        "Toelichting": "WIS00"
    },
    {
        "Code": 1128,
        "Waarde": "Wissenkerke",
        "Toelichting": "WSK00"
    },
    {
        "Code": 1129,
        "Waarde": "Witmarsum",
        "Toelichting": "WMS03"
    },
    {
        "Code": 1130,
        "Waarde": "Wittem",
        "Toelichting": "WTM00"
    },
    {
        "Code": 1131,
        "Waarde": "Woensdrecht",
        "Toelichting": "WDT00"
    },
    {
        "Code": 1132,
        "Waarde": "Woensel",
        "Toelichting": "WSL01"
    },
    {
        "Code": 1133,
        "Waarde": "Woerden",
        "Toelichting": "WDN01"
    },
    {
        "Code": 1134,
        "Waarde": "Wognum",
        "Toelichting": "WNM00"
    },
    {
        "Code": 1135,
        "Waarde": "Wolphaartsdijk",
        "Toelichting": "WPD00"
    },
    {
        "Code": 1136,
        "Waarde": "Wolvega",
        "Toelichting": "WVG00"
    },
    {
        "Code": 1137,
        "Waarde": "Wommels",
        "Toelichting": "WMS02"
    },
    {
        "Code": 1138,
        "Waarde": "Workum",
        "Toelichting": "WKM00"
    },
    {
        "Code": 1139,
        "Waarde": "Wormer",
        "Toelichting": "WMR00"
    },
    {
        "Code": 1140,
        "Waarde": "Wormerveer",
        "Toelichting": "WMV00"
    },
    {
        "Code": 1141,
        "Waarde": "Woubrugge",
        "Toelichting": "WBG00"
    },
    {
        "Code": 1142,
        "Waarde": "Woudenberg",
        "Toelichting": "WDB02"
    },
    {
        "Code": 1143,
        "Waarde": "Woudrichem",
        "Toelichting": "WDC00"
    },
    {
        "Code": 1144,
        "Waarde": "Woudsend",
        "Toelichting": "WED00"
    },
    {
        "Code": 1145,
        "Waarde": "Wouw",
        "Toelichting": "WOU00"
    },
    {
        "Code": 1146,
        "Waarde": "Yerseke",
        "Toelichting": "YSK00"
    },
    {
        "Code": 1147,
        "Waarde": "Zaamslag",
        "Toelichting": "ZSG00"
    },
    {
        "Code": 1148,
        "Waarde": "Zaandam",
        "Toelichting": "ZDM01"
    },
    {
        "Code": 1149,
        "Waarde": "Zaandijk",
        "Toelichting": "ZDK00"
    },
    {
        "Code": 1150,
        "Waarde": "Zalk",
        "Toelichting": "ZAL00"
    },
    {
        "Code": 1151,
        "Waarde": "Zaltbommel",
        "Toelichting": "ZBM00"
    },
    {
        "Code": 1152,
        "Waarde": "Zandvoort",
        "Toelichting": "ZVT00"
    },
    {
        "Code": 1153,
        "Waarde": "Zeddam",
        "Toelichting": "ZDM02"
    },
    {
        "Code": 1154,
        "Waarde": "Zederik",
        "Toelichting": "ZDR00"
    },
    {
        "Code": 1155,
        "Waarde": "Zeeland",
        "Toelichting": "ZLD02"
    },
    {
        "Code": 1156,
        "Waarde": "Zeewolde",
        "Toelichting": "ZWD03"
    },
    {
        "Code": 1157,
        "Waarde": "Zegveld",
        "Toelichting": "ZVD00"
    },
    {
        "Code": 1158,
        "Waarde": "Zegwaard",
        "Toelichting": "ZWD01"
    },
    {
        "Code": 1159,
        "Waarde": "Zeist",
        "Toelichting": "ZEI00"
    },
    {
        "Code": 1160,
        "Waarde": "Zelhem",
        "Toelichting": "ZHM00"
    },
    {
        "Code": 1161,
        "Waarde": "Zesgehuchten",
        "Toelichting": "ZGH00"
    },
    {
        "Code": 1162,
        "Waarde": "Zetten",
        "Toelichting": "ZTN00"
    },
    {
        "Code": 1163,
        "Waarde": "Zevenaar",
        "Toelichting": "ZVN01"
    },
    {
        "Code": 1164,
        "Waarde": "Zevenbergen",
        "Toelichting": "ZVB00"
    },
    {
        "Code": 1165,
        "Waarde": "Zevenhoven",
        "Toelichting": "ZVH01"
    },
    {
        "Code": 1166,
        "Waarde": "Zevenhuizen",
        "Toelichting": "ZVH02"
    },
    {
        "Code": 1167,
        "Waarde": "Zierikzee",
        "Toelichting": "ZRZ00"
    },
    {
        "Code": 1168,
        "Waarde": "Zijpe",
        "Toelichting": "ZPE00"
    },
    {
        "Code": 1169,
        "Waarde": "Zoelen",
        "Toelichting": "ZLN01"
    },
    {
        "Code": 1170,
        "Waarde": "Zoetermeer",
        "Toelichting": "ZTM00"
    },
    {
        "Code": 1171,
        "Waarde": "Zoeterwoude",
        "Toelichting": "ZTW01"
    },
    {
        "Code": 1172,
        "Waarde": "Zouteveen",
        "Toelichting": "ZTV00"
    },
    {
        "Code": 1173,
        "Waarde": "Zuid-Beijerland",
        "Toelichting": "BEL02"
    },
    {
        "Code": 1174,
        "Waarde": "Zuidbroek",
        "Toelichting": "ZBK00"
    },
    {
        "Code": 1175,
        "Waarde": "Zuidhorn",
        "Toelichting": "ZHN00"
    },
    {
        "Code": 1176,
        "Waarde": "Zuidland",
        "Toelichting": "ZLD01"
    },
    {
        "Code": 1177,
        "Waarde": "Zuidlaren",
        "Toelichting": "ZLR00"
    },
    {
        "Code": 1178,
        "Waarde": "Zuidwolde",
        "Toelichting": "ZWD02"
    },
    {
        "Code": 1179,
        "Waarde": "Zuidzande",
        "Toelichting": "ZZD00"
    },
    {
        "Code": 1180,
        "Waarde": "Zuilen",
        "Toelichting": "ZLN02"
    },
    {
        "Code": 1181,
        "Waarde": "Zuilichem",
        "Toelichting": "ZLC00"
    },
    {
        "Code": 1182,
        "Waarde": "Zundert",
        "Toelichting": "ZDT02"
    },
    {
        "Code": 1183,
        "Waarde": "Zutphen",
        "Toelichting": "ZPN00"
    },
    {
        "Code": 1184,
        "Waarde": "Zwammerdam",
        "Toelichting": "ZMD00"
    },
    {
        "Code": 1185,
        "Waarde": "Zwartewaal",
        "Toelichting": "ZTW02"
    },
    {
        "Code": 1186,
        "Waarde": "Zwartsluis",
        "Toelichting": "ZSS00"
    },
    {
        "Code": 1187,
        "Waarde": "Zweeloo",
        "Toelichting": "ZLO00"
    },
    {
        "Code": 1188,
        "Waarde": "Zwijndrecht",
        "Toelichting": "ZDT01"
    },
    {
        "Code": 1189,
        "Waarde": "Zwolle",
        "Toelichting": "ZLE00"
    },
    {
        "Code": 1190,
        "Waarde": "Zwollerkerspel",
        "Toelichting": "ZLK00"
    },
    {
        "Code": 1191,
        "Waarde": "Nes Ameland",
        "Toelichting": "NES01"
    },
    {
        "Code": 1192,
        "Waarde": "Werken van algemeen belang",
        "Toelichting": "WAB00"
    }
]